/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-07-20 15:04:15
 * @LastEditors: linxi
 * @LastEditTime: 2025-11-14 15:35:09
 */
import {
  CaretDownFilled,
  CloseCircleFilled,
  CloseOutlined,
  ExclamationCircleFilled,
  InfoCircleOutlined,
  RightOutlined,
  SearchOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Input,
  Menu,
  message,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Cascader as Cascaded,
  Tooltip,
  Modal,
  Popover,
} from 'antd'
import * as U from '../../../models/user'
import moment from 'moment'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectPhone,
  selectApiUserType,
  selectCredentials,
  selectCycleCode,
  selectEdition,
  selectInsuranceArray,
  selectStationCategory,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantCategory,
  selectTenantId,
  selectTenantName,
  selectUserDepartmentId,
  selectUserId,
  selectUserName,
} from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { RefreshFilled, UnderageIcon } from '../../../compnents/icons/Icons'
import { Label } from '../../../compnents/widgets/Label'
import { selectMenus, traceRoute } from '../../../layouts/layoutSlice'
import { PaymentConfirmation } from '../../../models/confirmation'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
} from '../../../models/datetime'
import * as P from '../../../models/patient'
import {
  otherPatientInsuranceItemParams,
  PaymentRegistrationParams,
} from '../../../models/payment'
import { PrintTemplateCategory } from '../../../models/print'
import * as R from '../../../models/registration'
import {
  getSourceTypeName,
  getVisitTypeName,
  RegistrationCategory,
  SourceTypeCategories,
  VisitType,
} from '../../../models/registration'
import { MedicelListValue, Settings } from '../../../models/setting'
import { Gender, getGenderName, StationCategory } from '../../../models/user'
import { ThemeContext } from '../../../theme/ThemeContext'
import { useQuery } from '../../../utils/HttpUtils'
import { getTriageHistorylist } from '../../commonTriageDetail/commonTriageDetailSlice'
import {
  PaymentConfirm,
  PaymentConfirmRef,
} from '../../payment/confirm/PaymentConfirm'
import { PrintTemplateModal } from '../../print/PrintTemplateModal'
import { selectBooleanSetting, setSettings } from '../../settings/settingsSlice'
import { reSetRegistration } from '../../treatment/treatmentSlice'
import { getTriageItem } from '../../triage/listslice'
import styles from './Register.module.css'
import {
  getTradeName,
  IDCardRead,
  medicalSendHttp,
  readCardEHttp, readCardSfzHttp,
  readCardSHttp,
  strParse,
} from '../../../utils/MedicalUtils'
import {
  getAddress,
  getAppointmentPatientDetail,
  getFeeList,
  getIsSeeDoctor,
  getMedicalNum,
  getOutpatientDepartment,
  getPatientDetail,
  getPatientInfoAsync,
  getPatientList,
  getToDayListPage,
  medicalRegisterAsync,
  register,
  registerValue,
  searchPsnSumAsync,
  searchQueryPsnAsync,
  selectAppointmentId,
  selectDepartments,
  selectDoctors,
  selectFeeList,
  selectPatientDetail,
  selectPatientPageId,
  selectPatients,
  setAppointmentIdSlice,
  setPatient,
  getRylb,
  cancelPayMoneyAsync, openRegisterForSyldAsync,
  geRegistrationListAsync,
} from './registerSlice'
import {
  getTradeCode,
} from '../../../models/material'
import {
  selectInsuranceItem,
  setInsurance,
} from '../../../layouts/insuranceSlice'
import { serverType } from '../../../services/commodity'
import {
  clearConfirmation,
  FeeListUpAsync,
  getLastTreatmentTimeByPatientIdAndDoctorIdAsync,
  JuhePayCancle,
  JuhePayFn, MdtrtinfoUpAsync,
  pay,
  preSettlementAsync,
  saveSettlementAsync,
  SearchJuhePay,
  selectConfirmation,
} from '../../payment/confirm/paymentConfirmSlice'
import { Fee } from '../../../models/fee'
import { useHistory, useLocation } from 'react-router-dom'
import { getDepartments, oweMoney } from '../../payment/list/paymentSlice'
import { selectTenant } from '../../user/setting/settingSlice'
import { phonePatterns } from '../../../utils/RegExp'
import { setFlagText } from '../../setmeal/setmealSlice'
import { getYBTypeName } from '../../../models/ybType'
import {
  checkTreatmentAsync,
  finishTreatment,
  getTreatmentNotice,
  setPatientInfo,
} from '../../treatment/editor/recipeListEditorSlice'
import { TreatmentNotice } from '../../../models/treatment'
import { getCancel, getRegisterCancel } from '../../home/HomeSlice'
import { getAge } from '../../../utils/StringUtils'
import { JuheIptShowModal } from '../../payment/confirm/JuheIptShowModal'
import { MedicationAdministrationRecordModal } from '../../treatment/tcmCases/MedicationAdministrationRecordModal'
import { Checks } from '../../../models/personalSetting'
import { SettingOptionsModal } from '../../A-toothModule/toothHome/modal/settingOptionsModal'
import { pinyin } from 'pinyin-pro'
import { getCounselor, getPatientOptionsAsync } from '../../A-toothModule/toothHome/toothHomeSlice'

import { getCounselorListTimePage, getDoctorsInDepartmentTimeListAsync } from '../../treatment/blindPersonmedical/blindPersonmedicalSlice'
import { getDoctorsInDepartmentListAsync } from '../../completion/completionSlice'
import _ from 'lodash'
import { getSourceName } from '../../../models/ToothHome'
import {YBJRJSModal} from "../../retail/YBJRJSModal";
import { getFieldSettingList } from '../../FunctionSetting/functionSettingPage/fieldSetting/FieldSettingSlice'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { NATION_LIST } from '../../../models/nation'
import Draggable from "react-draggable";
import { geRegistrationConfigListAsync } from '../../FunctionSetting/functionSettingPage/registrationFeeSetting/RegistrationFeeSettingSlice'
import { getMaskPhone } from '../../../models/phone'

let timer: any = null
let GHLB: any = '' //挂号类别
let HZXB: any = ''//患者性别
let HZLY: any = ''//患者来源
let KSYS: any = ''//科室医生
let atDoctor: any = ''//默认医生
let localDepartmentId: any = ''//默认科室id
let localDoctorId: any = ''//默认医生id


interface RegisterProps {
  onSuccess?: () => void
  isPreferencesSettingVisible?: any
  activeKey?: any
}

export const Register = ({
  onSuccess,
  isPreferencesSettingVisible,
  activeKey,
}: RegisterProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [url_param, setUrlParam] = useState('')
  const [mdtrt_cert_type, setMdtrt_cert_type] = useState('')

  const handleReadPsn = (cardType: string) => {
    // 1. 入参
    const inParams:Record<string, string> = {
      fixmedins_code: insuranceItem.countryHospitalNb,
      user_name: loginPhone,
      transType: cardType,
    };


    const businessCallback = function (result:any) { // 接收 result: { code, success, data, errorMsg}
      setUrlParam('');
      setMdtrt_cert_type('');
      if (result.success) {
        const data = result.data;
        if (data.result == '-1') {
          notification.error({
            message: "读卡失败："+data.pErrMsg,
            duration: 3,
          })
          return;
        }
        //1101返回报文
        const psnInfo = {
          output: data?.psnInfoOut,
          infcode: "0",
          inf_refmsgid: "-1",
          refmsg_time: "-1",
          respond_time: "-1",
          enctype: "",
          signtype:"",
          err_msg:""
        }
        if(!psnInfo || !psnInfo?.output){
          notification.error({
            message: "读卡失败："+JSON.stringify(data),
            duration: 3,
          })
          return;
        }
        console.log("参保人员信息：", psnInfo);

        let fullCardInfo = '';
        if('card' == cardType){
          fullCardInfo = data?.dllOut?.pCardInfo;
          setUrlParam(fullCardInfo?.split("|")?.[2] +"|"+ data?.dllOut?.pBusiCardInfo);
          setMdtrt_cert_type('03')
        }else if('face' == cardType || 'ec' == cardType){
          // dzpzDataRes["userName"].ToString() + "|" + dzpzDataRes["idNo"].ToString() + "|" + dzpzDataRes["idType"].ToString() + "|" + dzpzDataRes["ecToken"].ToString() + "|" + dzpzDataRes["insuOrg"].ToString() + "|";
          const dzpzFull = data?.dllOut?.data;
          fullCardInfo = dzpzFull?.userName + "|" + dzpzFull?.idNo + "|" + dzpzFull?.idType + "|" +dzpzFull?.ecToken + "|" + dzpzFull?.insuOrg ;
          setUrlParam(dzpzFull?.ecToken) ;
          setMdtrt_cert_type('01')
        }else{
          notification.error({
            message: "读卡失败：不支持的读卡方式",
            duration: 3,
          })
          return;
        }
        getPatientInfo(
          fullCardInfo,
          '',
          '',
          'response',
          JSON.stringify(psnInfo)
        )
      } else {
        notification.error({
          message: result.errorMsg || "调用接口失败",
          duration: 3,
        })
      }
    };


    // 3. 生成唯一回调函数名（防并发冲突）
    const funName = "readPsnInfo";
    const tempFunName = `callFun_${funName}_${Date.now()}`;

    // 4. 挂载临时回调到 window，供 Electron 反向调用
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window[tempFunName] = function (result:any) {
      // 执行完立即删除，避免内存泄漏
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete window[tempFunName];
      businessCallback(result);
    };

    // ========== 关键：环境判断 ==========
    // 仅当在对方 Electron 壳中运行时，才调用 callSysFunc
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window.callSysFunc === "function") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.callSysFunc({
        funName: funName,
        params: inParams,
        callbackFun: tempFunName,
      });
    } else {
      // 本地浏览器/独立访问时，友好提示（可注释）
      console.log("当前不在 Electron 客户端环境，跳过调用");
      // alert("请在桌面客户端中运行！");
    }
  };


  const hisVersion: any = useSelector(selectEdition) //his版本 0通用 1口腔

  const oweMoneyShow: any = useSelector(selectTenant) //欠费是否显示

  const [oweMoneyNumShow, setOweMoneyNumShow] = useState(false) //欠费金额是否显示

  const menus = useSelector(selectMenus)

  const appointmentRef = useRef<HTMLDivElement>(null)

  const toDayConsultRef = useRef<HTMLDivElement>(null)
  const history = useHistory()

  const { Option } = Select

  const [form] = Form.useForm()

  const location: any = useLocation()

  const ref = useRef<PaymentConfirmRef>(null)

  const readCardRef = useRef<any>(null)

  const theme = useContext(ThemeContext)

  const departments = useSelector(selectDepartments)

  const [lastTreatmentTimeInfo, setLastTreatmentTimeInfo] = useState<any>()
  const tenantId = useSelector(selectTenantId)

  const query = useQuery()

  const credentials = useSelector(selectCredentials)

  const patients = useSelector(selectPatients)

  const patient = useSelector(selectPatientDetail)

  const refreshSJHQX = query.get('refreshSJHQX')

  const [doctors, setDoctors] = useState<any[]>()

  const [treatmentAssistantDoctorList, setTreatmentAssistantDoctorList] = useState<any[]>() //  助理医师数据

  // const doctors = allDoctors?.filter((v) => v?.stationCategory == 1)

  const userId = useSelector(selectUserId)

  const departmentId = useSelector(selectUserDepartmentId)

  const isPatientPageId = useSelector(selectPatientPageId)

  const storageDepartmentId =
    localStorage.getItem('registrationDepartmentId') || departmentId  //科室id

  const storageDoctorId =
    localStorage.getItem('registrationDoctorId') || userId  //医生id

  //0.取最新的偏好设置内容
  const localData: any = JSON.parse(
    localStorage.getItem('preferencesSettingData') || '{}'
  )

  const appointFlag = localStorage.getItem('appointFlag') //预约进到挂号页面的标志

  const [checkData, setCheckData] = useState<any>([])

  const fees = useSelector(selectFeeList)

  const skipPrinting = useSelector(
    selectBooleanSetting(Settings.Registration.SkipPrinting)
  )

  const [
    isMedicationAdministrationRecordVisible,
    setIsMedicationAdministrationRecordVisible,
  ] = useState(false)

  const [allList, setAllList] = useState<any[]>() //省市数据

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [sumVisible, setSumVisible] = useState(false)

  const [xianzhongVisible, setXianzhongVisible] = useState(false)

  const [sumList, setSumList] = useState<any>()

  const [phoneInfo, setPhoneInfo] = useState<any>({})

  const [xianzhongList, setXianzhongList] = useState<any[]>() //省市数据
  const [selectXianzhong, setSelectXianzhong] = useState<any>() //选中的险种

  const [notice, setNotice] = useState<TreatmentNotice | undefined>()

  const [keyword, setKeyword] = useState('')

  const [keywords, setKeywords] = useState('')

  const [nameFlag, setNameFlag] = useState(false)

  const [flag, setFlag] = useState(false)

  const [cardType, setCardType] = useState<any>() // 读卡类型

  const [faceAuth, setFaceAuth] = useState(false)

  const [diabled, setDiabled] = useState<any>(false)

  const [patientId, setPatientId] = useState('')

  const [TriageDetailId, setTriageDetailId] = useState('')

  const [list, setList] = useState<any[]>([])

  const [registerData, setRegisterData] = useState<registerValue>()

  const [triageDetail, setTriageDetail] = useState<any>()

  const [sexTag, setSexTag] = useState(false)

  const [confirmation, setConfirmation] = useState<
    PaymentConfirmation | undefined
  >(undefined)

  const [ybJiuzhenid, setYbJiuzhenid] = useState('')

  const [registrationId, setRegistrationId] = useState('')

  const [printPaymentId, setPrintPaymentId] = useState('')

  const [printTreatmentId, setPrintTreatmentId] = useState('')

  const [idCard, setIdCard] = useState('')

  const [source, setSource] = useState(0)

  const [lableNameList, setLableNameList] = useState<any[]>([])

  const [allLableNameList, setAllLableNameList] = useState<any[]>([])

  const [cancelOrSaveLoading, setCancelOrSaveLoading] = useState(false)

  const [loading, setLoading] = useState(false)

  const [registerLoading, setRegisterLoading] = useState(false)

  const [tongchouLJ, setTongchouLJ] = useState('')

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: '身份证格式错误',
    },
    {
      max: 18,
      message: '最长18位!',
    },
  ])
  const [idCardInputValid, setIdCardInputValid] = useState(false)
  const [value, setValue] = useState<any>('0')

  const [GHCKHZSJHData, setGHCKHZSJHData] = useState<any>(true)

  // 获取挂号查看患者手机号数据权限
  const getCheckPermissionFn = () => {
     dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.GHCKHZSJH }))
       .then(unwrapResult)
       .then((res: any) => {
         setGHCKHZSJHData(res)
       })
  }
   
  useEffect(() => {
    if (activeKey == '0' || refreshSJHQX) {
      getCheckPermissionFn()
    }
  }, [activeKey, refreshSJHQX])

  useEffect(() => {
    setNameFlag(false)
    setSexTag(false)
  }, [])

  // 获取科室
  useEffect(() => {
    dispatch(getOutpatientDepartment())
  }, [dispatch])


  useEffect(() => {
    if (!isPreferencesSettingVisible) {
      setFlag(false)
    }
  }, [isPreferencesSettingVisible])

  useEffect(() => {
    if (keywords) {
      form.setFieldsValue({
        name: keywords,
      })
    }
  }, [keywords])

  const [isPatientOverlayVisible, setIsPatientOverlayVisible] = useState(false)

  const [
    isPatientNameOverlayVisible,
    setIsPatientNameOverlayVisible,
  ] = useState(false)

  const [fullCardInfo, setFullCardInfo] = useState<string>()
  const [qrCode, setQrCode] = useState<string>()
  const [chnlId, setChnlid] = useState<string>()

  const [patientInsurance, setPatientInsurance] = useState<any>()

  const [yBZFRegister, setYBZFRegister] = useState(false) //自费挂号
  const [isOpen, setIsOpen] = useState(false);

  const [url,setUrl] = useState('')


  const [insuranceItem, setInsuranceItem] = useState<any>()

  const [isHisCode, setIsHisCode] = useState(false)

  const [skipPrintingFlag, setSkipPrintingFlag] = useState(false)

  const [hasCard, setHasCard] = useState(false)
  const [otherCountyCard, setOtherCountyCard] = useState(false)

  const [readLoadingDzpz, setReadLoadingDzpz] = useState(false)
  const [readLoadingSfz, setReadLoadingSfz] = useState(false)
  const [readLoadingStk, setReadLoadingStk] = useState(false)
  const [readLoadingRl, setReadLoadingRl] = useState(false)

  const insuranceArray = useSelector(selectInsuranceArray)

  const userName = useSelector(selectUserName)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantName = useSelector(selectTenantName)

  const baseData = useSelector(selectInsuranceItem)

  const tenantCategory = useSelector(selectTenantCategory)

  const stationCategory = useSelector(selectStationCategory)

  const cycleCode = sessionStorage.getItem('cycleCode')

  const [
    otherPatientInsuranceItem,
    setOtherPatientInsuranceItem,
  ] = useState<otherPatientInsuranceItemParams>({})

  const [isInsurance, setIsInsurance] = useState(false)


  const [showStopAction, setShowStopAction] = useState(false)

  const [showJHZFAction, setShowJHZFAction] = useState(false)

  const [toDayList, setToDayList] = useState<any>() //今日预约列表

  const [isShowToDay, setIsShowToDay] = useState(false) //今日预约是否显示

  const [isShowModal, setIsShowModal] = useState(false)
  const [appointmentId, setAppointmentId] = useState('')

  const [oweMoneyNum, setOweMoneyNum] = useState<any>(null)

  const [owelabel, setoweLabel] = useState<any>([])

  const [treatmentNum, setReatmentNum] = useState<any>()

  const [isAdult, setIsAdult] = useState(false)
  const [ageUnit, setAgeUnit] = useState<'year' | 'month'>('year')

  const isAppointmentId = useSelector(selectAppointmentId)
  const [searchPsnSumDisabled, setSearchPsnSumDisabled] = useState<boolean>(
    false
  )
  const apiUserType = useSelector(selectApiUserType)

  const loginPhone = useSelector(selectPhone)

  const [sameDayRegistrationFee, setSameDayRegistrationFee] = useState<any>('')

  const [watchedDoctorId, setWatchedDoctorId] = useState<any>(undefined)
  const [watchedAdvance, setWatchedAdvance] = useState(
    localStorage.getItem('registrationCharge') === 'true'
  )
  const [watchedReceiveTag, setWatchedReceiveTag] = useState<any>(VisitType.First)

  const [
    isCancelRegisterModalVisible,
    setIsCancelRegisterModalVisible,
  ] = useState(false)

  const triagePatientInfo = JSON.parse(
    sessionStorage.getItem('TRIAGEPATIENTINFO') || '{}'
  ) // 预检分诊页面过来

  const [JuheIptDisabled, setJuheIptDisabled] = useState(false) //扫码输入框是否禁用

  const [JuheIptShow, setJuheIptShow] = useState(false) //扫码输入框是否显示

  const [payCode, setPayCode] = useState('')

  const [juhePayId, setjuhePayId] = useState() //聚合支付保存ID

  const [timerFlag, setTimerFlag] = useState(false) //聚合循环调用接口

  const [cancelPayBtn, setCancelPayBtn] = useState(false) //撤销收款按钮是否显示

  const [JuheText, setJuheText] = useState('请扫描（微信/支付宝）付款码') //聚合循环调用接口

  const [classificationList, setClassificationList] = useState<any>() //自定义患者来源数据

  const [settingOptionsVisible, setSettingOptionsVisible] = useState(false) //自定义选项
  const [isYBJRJSModalVisible, setIsYBJRJSModalVisible] = useState<any>()
  const [tradeCntInfo, setTradeCntInfo] = useState<any>({})

  const [settingType, setSettingType] = useState('0') // 自定义类型

  const [fieldSettingList, setFieldSettingList] = useState<any>([]) // 自定义字段设置

  useEffect(() => {
    if (classificationList?.sourceList) {
      setDefaultPatientSource();
    }
  }, [classificationList])

  useEffect(() => {
    if (JuheIptShow) {
      setJuheIptDisabled(false)
    } else {
      if (skipPrintingFlag) {
        // 打印
        setRegistrationId(String(registerData?.registrationId))
        setPrintPaymentId(String(registerData?.paymentId))
        setPrintTreatmentId(String(registerData?.treatmentId))
      } else {
        setRegistrationId('')
        setPrintPaymentId('')
        setPrintTreatmentId('')
      }
    }
  }, [JuheIptShow, skipPrintingFlag])
  // const getType = () => {   //获取接诊类型是否显示
  //   dispatch(getAcceptsType({
  //     type: '34',
  //   })).then(unwrapResult).then((res) => {
  //     setAcceptsType(res)
  //   })
  // }\

  useEffect(() => {
    setYBZFRegister(false)
    setSkipPrintingFlag(false)
  }, [])

  useEffect(() => {
    if (timerFlag && !timer) {
      timer = setInterval(() => {
        juheFn()
      }, 2000)
    }
    if (!timerFlag && timer) {
      clearInterval(timer)
      timer = null
    }
    return () => {
      timer && clearInterval(timer)
      timer = null
    }
  }, [timerFlag])


  useEffect(() => {
    getLastTreatmentTimeByPatientIdAndDoctorId(form.getFieldValue("registrationDoctorId"), patientId);
  }, [patientId])

  // 患者选择后，同步医生和接诊类型状态到 React state（处理通过 setFieldsValue 程序设置但未触发 onChange）
  useEffect(() => {
    if (patientId) {
      const doctorId = form.getFieldValue('registrationDoctorId')
      if (doctorId && doctorId !== '0') {
        setWatchedDoctorId(doctorId)
      }
      const tag = form.getFieldValue('receiveTag')
      if (tag !== undefined && tag !== null) {
        setWatchedReceiveTag(tag)
      }
    }
  }, [patientId])

  // 患者、医生、预收挂号费都选择后，自动根据医生挂号费配置填充费用
  useEffect(() => {
    if (!patientId || !watchedDoctorId || watchedDoctorId === '0') return
    if (!watchedAdvance) return

    dispatch(geRegistrationConfigListAsync({ userId: watchedDoctorId, current: 1 }))
      .then(unwrapResult)
      .then((res: any) => {
        if (!res?.records?.length) return
        const config = fees?.filter((v) => v?.id == res.records[0])?.length ? res.records[0] : ''
        const { settingPattern, firstFeeIds, afterFeeIds, validTime } = config

        const parseFeeIds = (ids: string) =>
          ids ? String(ids).split(',').filter(Boolean) : []

        if (settingPattern === 0) {
          // 所有患者挂号费相同
          form.setFieldsValue({ registrationFeeId: parseFeeIds(firstFeeIds) })
        } else if (settingPattern === 1) {
          // 初复诊不同
          const feeIds = watchedReceiveTag === VisitType.First ? firstFeeIds : afterFeeIds
          form.setFieldsValue({ registrationFeeId: parseFeeIds(feeIds) })
        } else if (settingPattern === 2) {
          // 短期内再诊不同，需要判断距上次挂号时间
          const patientName = form.getFieldValue('name')
          dispatch(
            geRegistrationListAsync({
              param: patientName,
              treatmentDoctorId: String(watchedDoctorId),
              current: 1,
              isCheckUp: true
            })
          )
            .then(unwrapResult)
            .then((lastRes: any) => {
              const records = lastRes?.records
              if (records?.length) {
                const lastTime = moment(records[0].registrationTime)
                const diffDays = moment().diff(lastTime, 'days')
                const feeIds = diffDays > Number(validTime || 0) ? firstFeeIds : afterFeeIds
                form.setFieldsValue({ registrationFeeId: parseFeeIds(feeIds) })
              } else {
                // 无历史挂号记录，使用首诊费用
                form.setFieldsValue({ registrationFeeId: parseFeeIds(firstFeeIds) })
              }
            })
            .catch(() => {
              form.setFieldsValue({ registrationFeeId: parseFeeIds(firstFeeIds) })
            })
        }
      })
      .catch(() => {
        // 静默失败
      })
  }, [patientId, watchedDoctorId, watchedAdvance, watchedReceiveTag])

  const getLastTreatmentTimeByPatientIdAndDoctorId = async (doctorId: any, patientId: any) => {
    if (!doctorId || !patientId) {
      setLastTreatmentTimeInfo("");
      return;
    }
    // 查询聚合支付状态
    dispatch(
      getLastTreatmentTimeByPatientIdAndDoctorIdAsync({
        patientId: patientId,
        doctorId
      })
    ).then(unwrapResult)
      .then((res: any) => {
        if (res) {
          if (res && res?.length > 10) {
            setLastTreatmentTimeInfo("该医生于：" + res + " 接诊过该患者。");
          } else {
            setLastTreatmentTimeInfo("");
          }

        }
      })
      .catch(() => {
        //不做处理
      })
  }
  // 聚合支付保存
  const juheFn = async () => {
    // 查询聚合支付状态
    dispatch(
      SearchJuhePay({
        treatmentId: registerData?.treatmentId as any,
        recipeIdList: registerData?.payment?.recipeIdList || [],
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setjuhePayId(res.payId)
        if (res.status == -1) {
          //2支付失败 3已退费 4 撤销支付
          setJuheIptDisabled(false)
          setTimerFlag(false) //关闭定时器
          setJuheText('用户尚未支付，请扫码')
          setPayCode('')
          setCancelPayBtn(false)
        } else if (res.status == 0) {
          //支付中
          setTimerFlag(true) //开启定时器
          setJuheText('用户正在支付')
          setJuheIptDisabled(true)
          setCancelPayBtn(true) //撤销支付按钮
        } else if (res.status == 1) {
          //支付成功
          notification.success({
            message: '支付成功',
            duration: 1,
          })
          setTimerFlag(false) //关闭定时器
          setJuheIptDisabled(false)
          setJuheText('已完成支付，请稍等')
          setPayCode('')
          setCancelPayBtn(false)
          //聚合支付收费之后，如果是快速接诊的场景，则跳转页面

          form.validateFields().then((values) => {
            if (!values.skipPrinting) {
              setSkipPrintingFlag(true)
            } else {
              if (query.has('redirect') && values.skipPrinting && registerData?.registrationId && registerData?.registrationId > 0) {
                dispatch(
                  traceRoute({
                    name: '医生门诊',
                    path: '/treatment',
                    query: `registrationId=${registerData?.registrationId}`,
                  })
                )
              }
            }
          })
          setTimeout(() => {
            setJuheIptShow(false)
            revertPage()
            setJuheText('请扫描（微信/支付宝）付款码')
          }, 500)
        } else if (res.status == 3) {
          //3已退费
          setJuheIptDisabled(false)
          setJuheText('该笔聚合支付已退费，请重新扫码支付')
        }
        if (res.status == 2 || res.status == 4) {
          //2支付失败 3已退费 4 撤销支付
          setJuheIptDisabled(false)
          setTimerFlag(false) //关闭定时器
          setJuheText('支付失败或撤销支付，请重新扫码进行支付')
          setPayCode('')
          setCancelPayBtn(false)
        }
      })
      .catch(() => {
        setJuheIptShow(false)
        setPayCode('')
        setCancelPayBtn(false)
        setTimerFlag(false) //关闭定时器
        revertPage()
        setJuheText('请扫描（微信/支付宝）付款码')
      })
  }

  const isSee = (
    patientId?: string,
    idCard?: string,
    name?: string,
    phone?: number
  ) => {
    let params = {}
    if (patientId != '') {
      params = {
        patientId,
      }
    } else {
      params = {
        idCard,
        name,
        phone,
      }
    }
    //查询是否就诊
    dispatch(getIsSeeDoctor(params))
      .then(unwrapResult)
      .then((res: any) => {
        form.setFieldsValue({
          receiveTag: res.receiveTag,
        })
      })
  }

  const isAdultFn = (idCard: string, birthday: string) => {
    const isAdultByBirthday = (bir: string) => {
      const birthDate = new Date(bir)
      const currentDate = new Date()
      let age = currentDate.getFullYear() - birthDate.getFullYear()
      const currentMonth = currentDate.getMonth()
      const birthMonth = birthDate.getMonth()
      const currentDay = currentDate.getDate()
      const birthDay = birthDate.getDate()
      if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
        age--
      }
      return age >= 18
    }
    if (idCard && idCard.trim() !== '') {
      let birthDateStr = ''
      if (idCard.length === 15) {
        birthDateStr = '19' + idCard.substring(6, 12)
      } else {
        birthDateStr = idCard.substring(6, 14)
      }
      const formattedBirthday = `${birthDateStr.substring(0, 4)}/${birthDateStr.substring(4, 6)}/${birthDateStr.substring(6, 8)}`
      if (isAdultByBirthday(formattedBirthday)) {
        setIsAdult(false)
      } else {
        setIsAdult(true)
      }
      return
    }

    // 如果身份证号为空，使用生日判断
    if (birthday && birthday.trim() !== '') {
      if (isAdultByBirthday(birthday)) {
        setIsAdult(false)
      } else {
        setIsAdult(true)
      }
      return
    }
  }

  useEffect(() => {
    const sexValue = form.getFieldValue('sex')
    const ageYearValue = form.getFieldValue('ageYear')
    const ageValue = form.getFieldValue('age')
    const ageMonthValue = form.getFieldValue('ageMonth')
    const ageDayValue = form.getFieldValue('ageDay')
    const birthdayValue = form.getFieldValue('birthday')
    const phoneValue = form.getFieldValue('phone')
    const idCardNumberValue = form.getFieldValue('idCardNumber')
    const addressValue = form.getFieldValue('address')

    if (Object.keys(triagePatientInfo)?.length) {
      setSource(triagePatientInfo?.source || 0)
      form.setFieldsValue({
        ...triagePatientInfo?.sex,
        name: nameFlag ? keywords : triagePatientInfo.name,
        sex: sexTag ? sexValue : triagePatientInfo?.sex,
        ageYear: ageYearValue?.toString() || triagePatientInfo?.ageYear,
        age: ageValue?.toString() || triagePatientInfo?.age,
        ageMonth: ageMonthValue?.toString() || triagePatientInfo?.ageMonth,
        ageDay: ageDayValue?.toString() || triagePatientInfo?.ageDay,
        area: triagePatientInfo?.provinceCode
          ? [
            Number(triagePatientInfo?.provinceCode),
            Number(triagePatientInfo?.cityCode),
            Number(triagePatientInfo?.contryCode),
          ]
          : [],
        birthday:
          birthdayValue?.toString() ||
          (triagePatientInfo?.birthday
            ? moment(triagePatientInfo?.birthday).format(DateTimeFormatSimple)
            : ''),
        phone: phoneValue?.toString() || triagePatientInfo?.phone,
        idCardNumber:
          idCardNumberValue?.toString() || triagePatientInfo?.idCardNumber,
        address: addressValue?.toString() || triagePatientInfo?.address,
      })
      if (triagePatientInfo?.idCardNumber) {
        getIdCardInfo(triagePatientInfo?.idCardNumber)
      } else if (triagePatientInfo?.birthday) {
        updateYearsAndMonths()
      }
      setKeywords(nameFlag ? keywords : triagePatientInfo.name)
      isAdultFn(idCardNumberValue?.toString() || triagePatientInfo?.idCardNumber, birthdayValue?.toString() ||
        (triagePatientInfo?.birthday
          ? moment(triagePatientInfo?.birthday).format(DateTimeFormatSimple)
          : ''))
    }
  }, [keywords])

  useEffect(() => {
    const session_print: any = localStorage.getItem('registrationPrint') || 'true'
    const session_charge: any = localStorage.getItem('registrationCharge') || 'false'

    form.setFieldsValue({
      skipPrinting: session_print ? (session_print == 'true' ? true : false) : true,
      receiveInAdvance: session_charge ? (session_charge == 'true' ? true : false) : false,
    })
    return () => {
      dispatch(setAppointmentIdSlice(''))
    }
  }, [])

  useEffect(() => {
    revertPage()
  }, [HZXB, atDoctor, GHLB])

  const required = {
    rules: [
      {
        required: true,
      },
    ],
  }

  const formGutter = 20

  const firstColumnLayout = {
    labelCol: {
      flex: '0 0 6rem',
    },
  }

  const secondColumnLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const tipsColumnLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  }

  const thirdColumnLayout = {
    labelCol: {
      flex: '0 0 6rem',
    },
  }

  // 患者管理过来
  useEffect(() => {
    if (isPatientPageId) {
      dispatch(getPatientDetail(isPatientPageId))
    }
  }, [isPatientPageId])

  useEffect(() => {
    // 预约回显
    if (isAppointmentId) {
      setAppointmentId(isAppointmentId)
      dispatch(getAppointmentPatientDetail(isAppointmentId))
      setIsShowModal(false)
    }
  }, [isAppointmentId])

  const getOweMoneyFn = (
    patientId?: string,
    idCard?: number,
    name?: string,
    phone?: number
  ) => {
    let params = {}
    if (patientId != '') {
      params = {
        patientId,
      }
    } else {
      params = {
        idCard,
        name,
        phone,
      }
    }
    dispatch(oweMoney(params)) //是否欠费
      .then(unwrapResult)
      .then((res) => {
        if (
          res.arrearageAmountSum > 0 &&
          RegistrationCategory.SelfPay == 0 &&
          (value == '0' || value == '')
        ) {
          setOweMoneyNumShow(true)
        } else {
          setOweMoneyNumShow(false)
        }
        setOweMoneyNum(res.arrearageAmountSum)
        setoweLabel(res.labels)
      })
  }
  const patientOverlay = (
    <Menu style={{ maxHeight: 360, overflow: 'auto' }}>
      {patients.map((p) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            form.setFieldsValue({
              patientId: p.id,
            })
            isAdultFn(p.idCardNumber, p.birthday)
            getOweMoneyFn(p.id) //是否欠费
            isSee(p.id) //是否就诊过
            setAppointmentId('')
            setIsPatientOverlayVisible(false)
            setIsPatientNameOverlayVisible(false)
            dispatch(getPatientDetail(p.id))
            setDiabled(true)
            sessionStorage.removeItem('TRIAGEPATIENTINFO')
          }}
        >
          <Space>
            <span>{p.name}</span>
            <span>{getGenderName(p.sex)}</span>
            <span>{getAge(p.ageYear, p.ageMonth, '岁', p.ageDay)}</span>
            <span>{p.phone ? (!GHCKHZSJHData ? getMaskPhone(p.phone) : p.phone) : ''}</span>
            <span>{p.id}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )
  const taiagelistOverlay = (
    <Menu>
      {list.map((p) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            setDiabled(true)
            setIsPatientOverlayVisible(false)
            isAdultFn(p.idCardNumber, p.birthday)
            dispatch(getTriageItem(p.id))
              .then(unwrapResult)
              .then((v) => {
                setTriageDetail(v)
              })
            sessionStorage.removeItem('TRIAGEPATIENTINFO')
          }}
        >
          <Space>
            <span>{p.patientName}</span>
            <span>{getGenderName(p.sex)}</span>
            <span>{getAge(p.ageYear, p.ageMonth, '岁', p.ageDay)}</span>
            <span>{p.phone}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )

  const getIdCardInfo = (idCard: string) => {
    const date = new Date()
    const getMonth = date.getMonth() + 1 //当前月份
    const getDay = date.getDate() //当前日期
    const getFullYear = date.getFullYear() //当前年份

    let month = 0
    let year = 0
    let day = 0
    let birthday = ''
    //  身份证上的年月日
    if (idCard) {
      //先判断是不是中国大陆身份证
      if (
        (idCard.length != 15 && idCard.length != 16 && idCard.length != 18) ||
        isNaN(Number(idCard.substr(0, 6)))
      ) {
        setOtherCountyCard(true)
        setIdCardInputValid(false)
        setIdCardRules([
          {
            max: 18,
            message: '最长18位!',
          },
        ])
      } else {
        setOtherCountyCard(false)
        setIdCardInputValid(true)
        setIdCardRules([
          {
            pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '身份证格式错误',
          },
          {
            max: 18,
            message: '最长18位!',
          },
        ])
        const sex = Number(idCard?.[idCard?.length - 2]) % 2 == 0 ? 2 : 1
        if (idCard.length === 18) {
          month = parseInt(idCard?.substr(10, 2)) //身份证上的月份
          year = parseInt(idCard?.substr(6, 4)) //身份证上的年份
          day = parseInt(idCard?.substr(12, 2)) //身份证上的日期
          birthday = moment(idCard?.substr(6, 8)).format(DateTimeFormatSimple)
          // 通过身份证倒数第二位判断男女 奇数男 偶数女
          form.setFieldsValue({
            sex: sex,
          })
        } else if (idCard.length === 15 || idCard.length === 16) {
          //16位示例3305229603021031，少了两位年份
          //15位示例330522960302103，少了两位年份，最后的序号是3位
          month = parseInt(idCard?.substr(8, 2)) //身份证上的月份
          year = parseInt('19' + idCard?.substr(6, 2)) //身份证上的年份
          day = parseInt(idCard?.substr(10, 2)) //身份证上的日期
          birthday = moment('19' + idCard?.substr(6, 6)).format(
            DateTimeFormatSimple
          )
          form.setFieldsValue({
            sex: sex,
          })
        }
        if (
          (idCard.length != 18 && idCard.length != 16 && idCard.length != 15) ||
          idCard === ''
        ) {
          form.setFieldsValue({
            ageYear: '',
            age: '',
            ageMonth: '',
            ageDay: '',
            birthday: '',
            sex: 0,
          })
        } else {
          let ageYear = 0
          let ageMonth = 0
          if (getMonth - month > 0) {
            ageYear = getFullYear - year < 0 ? 1 : getFullYear - year
            ageMonth = getMonth - month
            if (getDay < day) ageMonth = Math.max(0, ageMonth - 1)
          } else if (getMonth - month < 0) {
            ageYear = getFullYear - year - 1 < 0 ? 1 : getFullYear - year - 1
            ageMonth = 12 - (month - getMonth)
            if (getDay < day) ageMonth = Math.max(0, ageMonth - 1)
          } else if (getMonth - month === 0) {
            if (getDay < day) {
              ageYear = getFullYear - year - 1 < 0 ? 1 : getFullYear - year - 1
              ageMonth = 11
            } else {
              ageYear = getFullYear - year < 0 ? 1 : getFullYear - year
              ageMonth = 0
            }
          }
          const totalMonths = ageYear * 12 + ageMonth
          if (totalMonths < 12) {
            // 小于1岁，使用月/天模式
            setAgeUnit('month')
            // 计算剩余天数
            let ageDayValue = moment().diff(moment(birthday).add(totalMonths, 'months'), 'days')
            // 防止天数计算出负（溢出到下一个月）
            if (ageDayValue < 0 && totalMonths > 0) {
              ageDayValue = moment().diff(moment(birthday).add(totalMonths - 1, 'months'), 'days')
              form.setFieldsValue({
                ageMonth: totalMonths - 1 <= 0 ? 0 : totalMonths - 1,
                ageDay: ageDayValue,
                birthday: birthday,
              })
            } else {
              form.setFieldsValue({
                ageMonth: totalMonths <= 0 ? 0 : totalMonths,
                ageDay: ageDayValue,
                birthday: birthday,
              })
            }
          } else {
            // 大于等于1岁，使用岁/月模式
            setAgeUnit('year')
            form.setFieldsValue({
              ageYear: ageYear < 0 ? 1 : ageYear,
              age: ageYear < 0 ? 1 : ageYear,
              ageMonth: ageMonth <= 0 ? 0 : ageMonth,
              birthday: birthday,
            })
          }
        }
      }
    } else {
      setIdCardInputValid(false)
    }
  }

  const success = (str: string, type: number) => {
    if (type === 1) {
      setReadLoadingDzpz(true)
      const hide = message.loading(str, 0)
      setTimeout(() => {
        hide()
        setReadLoadingDzpz(false)
      }, 3000)
    } else if (type === 2) {
      setReadLoadingSfz(true)
      const hide = message.loading(str, 0)
      setTimeout(() => {
        hide()
        setReadLoadingSfz(false)
      }, 3000)
    } else if (type === 3) {
      setReadLoadingStk(true)
      const hide = message.loading(str, 0)
      setTimeout(() => {
        hide()
        setReadLoadingStk(false)
      }, 3000)
    } else if (type === 4) {
      setReadLoadingRl(true)
      const hide = message.loading(str, 0)
      setTimeout(() => {
        hide()
        setReadLoadingRl(false)
      }, 10000)
    }
  }

  const successMessage = (str: string) => {
    setHasCard(true)
    notification.success({
      message: str,
    })
  }

  const readMessage = () => {
    if (hasCard && !otherCountyCard) {
      notification.info({
        message: '医保信息只读，不可修改',
        duration: 1,
      })
    }
  }

  const updateBirthdayTimer = useRef<any>(null)

  const updateBirthday = () => {
    clearTimeout(updateBirthdayTimer.current)
    updateBirthdayTimer.current = setTimeout(() => {
      if (ageUnit === 'year') {
        const year = parseInt(form.getFieldValue(source === 0 ? 'ageYear' : 'age')) || 0
        const month = parseInt(form.getFieldValue('ageMonth')) || 0
        if (year !== 0 || month !== 0) {
          const months = year * 12 + month
          const birthday = moment().subtract(months, 'months').format('YYYY/MM/DD')
          form.setFieldsValue({ birthday })
          isAdultFn('', birthday)
        }
      } else {
        const month = parseInt(form.getFieldValue('ageMonth')) || 0
        const day = parseInt(form.getFieldValue('ageDay')) || 0
        if (month !== 0 || day !== 0) {
          const birthday = moment().subtract(month, 'months').subtract(day, 'days').format('YYYY/MM/DD')
          form.setFieldsValue({ birthday })
          isAdultFn('', birthday)
        }
      }
    }, 300)
  }

  const updateYearsAndMonths = (brdy?: any) => {
    const date = brdy
      ? moment(brdy, ['YYYY/MM/DD', 'YYYY-MM-DD', 'YYYYMMDD'], true)
      : moment(
          form.getFieldValue('birthday'),
          ['YYYY/MM/DD', 'YYYY-MM-DD', 'YYYYMMDD'],
          true
        )
    if (!date.isValid()) {
      return
    }
    const now = moment()
    if (date.isAfter(now, 'day')) {
      return
    }
    const totalMonths = now.diff(date, 'months')
    if (totalMonths >= 12) {
      // 大于等于1岁，使用岁/月模式
      const year = Math.floor(totalMonths / 12)
      const month = totalMonths % 12
      setAgeUnit('year')
      form.setFieldsValue({
        ageYear: year,
        age: year,
        ageMonth: month,
      })
    } else {
      // 小于1岁，使用月/天模式
      const days = now.diff(date.clone().add(totalMonths, 'months'), 'days')
      setAgeUnit('month')
      form.setFieldsValue({
        ageMonth: totalMonths,
        ageDay: days,
      })
    }
  }


  const checkDepartment = (departmentId: any) => {
    return departments?.find((d) => d.id === departmentId?.toString())
  }

  const checkDoctor = (doctorId: any) => {
    return doctors?.find((d) => d.id === doctorId?.toString())
  }

  useEffect(() => {
    if (userId) {
      getPersonalSettingDetail()
    }
  }, [departments, appointFlag])

  const getPersonalSettingDetail = () => {
    // 获取挂号偏好设置 1000 1001 1002 1003
      const allPersonalPreferences = JSON.parse(localStorage?.getItem('allPersonalPreferences') || '{}')
      const res = allPersonalPreferences?.records || []
      setCheckData(res)
      const hzlb = res?.find((item: any) => item?.code == Checks.GHLB)?.codeName
      GHLB = hzlb?.toString() ? hzlb : localData?.insuranceStatus ? localData?.insuranceStatus : 'ZIFEI' //挂号类别

      const hzxb = res?.find((item: any) => item?.code == Checks.HZXB)?.codeName
      HZXB = hzxb?.toString() ? Number(hzxb) : localData?.sex ? localData?.sex : 0  //患者性别

      const hzly = res?.find((item: any) => item?.code == Checks.HZLY)?.codeName
      HZLY = hzly ? hzly : localData?.patientSource?.toString() ? getSourceTypeName(localData?.patientSource) : localData?.source?.toString() ? getSourceTypeName(localData?.source) : '' //患者来源

      KSYS = res?.find((item: any) => item?.code == Checks.KSYS)?.codeName //科室医生
      atDoctor = KSYS?.toString() ? Number(KSYS.split('#')[0]) : localData?.atDoctor?.toString() ? localData?.atDoctor : ''
      localDepartmentId = KSYS?.toString() ? (KSYS.split('#')[1])?.toString() : localData?.departmentId?.toString() ? localData?.departmentId : ''
      localDoctorId = KSYS?.toString() ? (KSYS.split('#')[2])?.toString() : localData?.doctorId?.toString() ? localData?.doctorId : ''
      DepartmentAndDoctorData()
  }

  const DepartmentAndDoctorData = () => {
    // 科室回填以及获取医生数据
    if (appointFlag != 'appointState') {
      // storeDepartmentId 上次的挂号科室
      if (atDoctor == 0) {
        // 偏好默认设置为空
        resetDepartmentDoctor()
      } else if (atDoctor == 1) {
        // 偏好默认设置为 '选中上一次挂号医生'
        if (departments?.length) {
          getDoctorListInDepartment(storageDepartmentId)
          if (
            checkDepartment(storageDepartmentId)
          ) {
            form.setFieldsValue({ registrationDepartmentId: storageDepartmentId })
          }
        }
      } else if (atDoctor == 2) {
        // 偏好设置的是选中 '指定医生' 科室id存储在前端浏览器中
        if (departments?.length) {
          getDoctorListInDepartment(localDepartmentId)
          if (
            checkDepartment(localDepartmentId)
          ) {
            form.setFieldsValue({ registrationDepartmentId: localDepartmentId })
          }
        }
      } else if (atDoctor == 3) {
        // 如果是偏好是 '当前账号医生' departmentId当前账号的科室id
        if (departments?.length) {
          getDoctorListInDepartment(departmentId)
          if (stationCategory == StationCategory.DoctorOrPharmacist) {
            if (checkDepartment(departmentId)) {
              form.setFieldsValue({
                registrationDepartmentId: departmentId,
              })
            }
          } 
        } 
      }
    }
  }

  // 医生回填
  useEffect(() => {
    if (appointFlag != 'appointState') {
      // storeDepartmentId 上次的挂号科室
      if (atDoctor == 1) {
        // 偏好默认设置为 '选中上一次挂号医生'
        if (checkDoctor(storageDoctorId)) {
          form.setFieldsValue({ registrationDoctorId: storageDoctorId })
        }
      } else if (atDoctor == 2) {
        // 偏好设置的是选中 '指定医生' 科室id存储在前端浏览器中
        if (checkDoctor(localDoctorId)) {
          form.setFieldsValue({ registrationDoctorId: localDoctorId })
        }
      } else if (atDoctor == 3) {
        // 如果是偏好是 '当前账号医生' departmentId当前账号的科室id
        if (stationCategory == StationCategory.DoctorOrPharmacist) {
          if (checkDoctor(userId)) {
            form.setFieldsValue({ registrationDoctorId: userId })
          }
        } 
      }
    }
  }, [appointFlag, doctors])


  const revertPage = () => {
    setTradeCntInfo({})
    setTongchouLJ('')
    setCardType('')
    setPatientId('')
    setTriageDetailId('')
    setSameDayRegistrationFee('')
    setHasCard(false)
    setDiabled(false)
    setYBZFRegister(false)
    form.setFieldsValue({
      ageYear: '',
      age: '',
      ageMonth: '',
      ageDay: '',
      birthday: '',
      name: '',
      phone: '',
      idCardNumber: '',
      companyName: '',
      address: '',
      emergencyContactName: '',
      emergencyContactPhone: '',
      sex: 0,
      source: '',
      patientSource: '',
      patientId: '',
    })
    setIsAdult(false)
    setAgeUnit('year')
    setKeywords('')
    setKeyword('')
    setOweMoneyNumShow(false) //欠费金额是否显示
    setPatientInsurance({})
    setLoading(false)
    setRegisterLoading(false)
    setLableNameList([])
    setAllLableNameList([])
    const vs = form.getFieldsValue()
    form.resetFields()
    setIdCardInputValid(false)
    form.setFieldsValue({
      skipPrinting: vs.skipPrinting,
      receiveInAdvance: vs.receiveInAdvance,
      area: [provinceCode, cityCode, countyCode],
      sex: HZXB,
    })

    getResiterMedicalNum()
    if (isHisCode) {
      form.setFieldsValue({
        registrationCategory: insuranceItem,
        readType: vs.readType,
      })
    }
    setHasCard(false)
    setPatientId('')
    setTriageDetailId('')
    setSumList({})
    setIsModalVisible(false)

    if (appointFlag != 'appointState') {
      // 偏好设置设置了空
      if (atDoctor == 0) {
        resetDepartmentDoctor()
      }
    }

    //1.根据偏好设置获取挂号类别（如果没有则取自费）
    const item = insuranceArray?.filter(
      (v: any) => v.insuranceCode == GHLB
    )?.[0]

    //如果偏好设置设置了自费，则改成自费
    if (GHLB == 'ZIFEI' || !item) {
      form.setFieldsValue({
        registrationCategory: 0,
      })
      setIsHisCode(false)
      setInsuranceItem({})
      setValue(0)
    } else {
      //否则，判断当前的类型是否和偏好设置一样，如果不一样则设置，一样就忽略（不能直接设置value未item，否则会选不中）
      const insuranceCode = form.getFieldValue('registrationCategory')?.insuranceCode
      if (insuranceCode != item?.insuranceCode) {
        form.setFieldsValue({
          registrationCategory: item || 0,
        })
      }
    }
    if (item && item.insuranceCode != 'ZIFEI') {
      setOweMoneyNumShow(false)
      setIsHisCode(true)
      setInsuranceItem(item)
      form.setFieldsValue({
        readType: 1,
      })
      setValue(item)
    }
    if (item == 0 && oweMoneyNum > 0) {
      //欠费金额是否显示
      setOweMoneyNumShow(true)
    }

    // 尝试设置默认患者来源（如果符合条件）
    setDefaultPatientSource();
    getPersonalSettingDetail()
    setUrlParam('');
    setMdtrt_cert_type('');
  }

  useEffect(() => {
    if (appointFlag != 'appointState') {
      if (doctors && doctors.length == 1) {
        if (checkDoctor(doctors[0].id)) {
          form.setFieldsValue({
            registrationDoctorId: doctors[0].id,
          })
        }
      }
    }
  }, [doctors, localStorage])

  const resetDepartmentDoctor = () => {
    form.setFieldsValue({
      registrationDepartmentId: undefined,
      registrationDoctorId: undefined,
    })
  }

  useEffect(() => {
    // dispatch(setDepartments(departments))
    setDoctors(doctors)
  }, [departments, doctors])

  useEffect(() => {
    if (patient) {
      setSameDayRegistrationFee(patient?.sameDayRegistrationFee)
      // sameDayRegistrationFee  == true ? '今日已收取挂号费' :''}
      if (
        checkDepartment(patient?.appointmentDepartmentId)
      ) {
        if (appointFlag == 'appointState') {
          getDoctorListInDepartment(patient?.appointmentDepartmentId as any)
          form.setFieldsValue({
            registrationDepartmentId: patient?.appointmentDepartmentId?.toString(),
            registrationDoctorId: checkDoctor(patient?.appointmentDoctorId)
              ? patient?.appointmentDoctorId?.toString()
              : '',
          })
        }
      }
    }
  }, [patient, departments, localStorage])

  const setDepartmentDoctorMessage = () => {
    // 挂号成功后选中上一次挂号医生
    if (atDoctor == 1) {
      const registrationDepartmentId = form.getFieldsValue()?.registrationDepartmentId as any
      const registrationDoctorId = form.getFieldsValue()?.registrationDoctorId as any
      localStorage.setItem(
        'registrationDepartmentId',
        registrationDepartmentId
      )
      localStorage.setItem(
        'registrationDoctorId',
        registrationDoctorId
      )
    }
  }

  useEffect(() => {
    let isPageRefreshed = false

    const handleBeforeUnload = () => {
      isPageRefreshed = true
    }

    const handleUnload = () => {
      if (isPageRefreshed) {
        // 清空localStorage中的数据
        localStorage.removeItem('appointFlag')
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    window.addEventListener('unload', handleUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      window.removeEventListener('unload', handleUnload)
    }
  }, [])

  const enterLoading = () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 5000)
  }

  const registerPayment = (
    values: Record<string, unknown>,
    prePay?: any,
    recipeId?: number
  ) => {
    const patient = {
      ...P.fromJson(values),
      id: patientId,
      ageMonth: parseInt(values.ageMonth as string) || 0,
      ageYear:
        ageUnit === 'month'
          ? 0
          : source == 1
            ? parseInt(values.age as string) || 0
            : parseInt(values.ageYear as string) || 0,
      ageDay: ageUnit === 'month' ? parseInt(values.ageDay as string) || 0 : 0,
      provinceCode: R.fromJson(values)?.area?.[0],
      cityCode: R.fromJson(values)?.area?.[1],
      contryCode: R.fromJson(values)?.area?.[2],
      patientSource: values.patientSource as string,
    }
    // 多选模式下，registrationFeeId可能是数组，计算所有选择费用的总和
    const feeIds = Array.isArray(values.registrationFeeId) 
      ? values.registrationFeeId 
      : [values.registrationFeeId]
    const totalAmount = feeIds.reduce((sum, feeId) => {
      const fee = fees.find((f) => f.id === feeId) as Fee
      return sum + (fee?.unitPrice || 0)
    }, 0)
    setConfirmation({
      patient: patient.name,
      amount: totalAmount,
      prePay,
      ids: recipeId,
      slots: [
        {
          name: '挂号费',
          value: totalAmount,
          children: feeIds.map(feeId => {
            const feeItem = fees.find((f) => f.id === feeId) as Fee
            return {
              name: feeItem?.name || '',
              value: feeItem?.unitPrice || 0,
              children: [],
            }
          }),
        },
      ],
      errorMaterials: [],
    })
    ref.current?.reset()
    setShowStopAction(false)
    setIsModalVisible(true)
  }

  const medicalSubmit = (vs: any, serverType: any, responseString?: string) => {
    const treatmentItem: any = departments.find(
      (v) => v.id === vs.registrationDepartmentId
    )
    const doctorItem: any = doctors?.find((v) => v.id === vs.registrationDoctorId)


    dispatch(
      medicalRegisterAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          begntime: moment().format(DateTimeFormatSimpleOnlyOne),
          cardType: vs.readType,
          cbxz: patientInsurance.cbxz,
          doctorCode: doctorItem?.countryCode,
          doctorName: doctorItem?.name,
          fullCardInfo:
            vs.readType == 2
              ? form.getFieldValue('idCardNumber')
              : fullCardInfo
                ? fullCardInfo
                : '',
          gwybz: patientInsurance.gwybz,
          insuranceRegion: patientInsurance.insuranceRegion,
          psnType: patientInsurance.memberType,
          treatmentDepartmentCode: treatmentItem.code,
          treatmentDepartmentName: treatmentItem.name,
          treatmentNo: treatmentNum,
          patientId: undefined,
          ybKebie: treatmentItem.ybKebie,
          ybPersonalNo: vs.ybPersonalNo,
          name: patientInsurance.name,
        },
      })
    )
      .then(unwrapResult)
      .then(async (res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              massage: '医保挂号',
            },
            (call: any, err) => {
              if (!err) {
                medicalSubmit(vs, 'response', JSON.stringify(call.netmessage))
              } else {
                setLoading(false)
                setRegisterLoading(false)
              }
            }
          )
        } else {
          setYbJiuzhenid(res.ybJiuzhenid)
          // resolve()
          submit({ ...vs, ybJiuzhenid: res.ybJiuzhenid }, undefined)
        }
      })
      .catch((v: any) => {
        setLoading(false)
        setRegisterLoading(false)
        if (v?.message?.indexOf('重新读卡挂号') != -1) {
          revertPage()
        }
      })
  }

  const submit = (
    values: Record<string, unknown>,
    params?: PaymentRegistrationParams
  ) => {
    dispatch(reSetRegistration({}))
    const patient = {
      ...P.fromJson(values),
      id: patientId,
      ageMonth: parseInt(values.ageMonth as string) || 0,
      ageYear:
        ageUnit === 'month'
          ? 0
          : source == 1
            ? parseInt(values.age as string) || 0
            : parseInt(values.ageYear as string) || 0,
      ageDay: ageUnit === 'month' ? parseInt(values.ageDay as string) || 0 : 0,
      provinceCode: R.fromJson(values)?.area?.[0],
      cityCode: R.fromJson(values)?.area?.[1],
      contryCode: R.fromJson(values)?.area?.[2],
      patientSource: values.patientSource as string,
    }

    const registration = {
      ...R.fromJson({
        ...values,
        registrationCategory: yBZFRegister ? 0 : values?.registrationCategory,
        ybJiuzhenid: values.ybJiuzhenid || ybJiuzhenid,
        appointmentId: appointmentId || undefined,
        treatmentNo: treatmentNum,
        area: undefined,
      }),
    }

    const patientInsuranceItem: any = {
      ...R.patientFromJson(patientInsurance),
      ...otherPatientInsuranceItem,
      fullCardInfo:
        values.readType == 2
          ? form.getFieldValue('idCardNumber')
          : fullCardInfo
            ? fullCardInfo
            : '',
      insuranceCode: insuranceItem?.insuranceCode,
      cardType: values.readType || cardType,
      dzpzQrCode: qrCode,
      dzpzChnlId: chnlId,
    }
    const department = checkDepartment(registration.registrationDepartmentId)
    registration.treatmentDepartmentId =
      registration.registrationDepartmentId || storageDepartmentId
    if (department) {
      registration.registrationDepartmentName = department.name
      registration.treatmentDepartmentName = department.name
    }
    registration.treatmentDoctorId = registration.registrationDoctorId
    const doctor = checkDoctor(registration.registrationDoctorId)
    if (doctor) {
      registration.registrationDoctorName = doctor.name
      registration.treatmentDoctorName = doctor.name
    }
    const treatmentAssistants = treatmentAssistantDoctorList?.find((d) => d.id == registration.treatmentAssistantDoctorId)
    if (treatmentAssistants) {
      registration.treatmentAssistantDoctorName = treatmentAssistants.realname
      registration.treatmentAssistantDoctorId = treatmentAssistants.id
    }
    // 多选模式下，registrationFeeId可能是数组，计算所有选择费用的总和
    const feeIds = Array.isArray(values.registrationFeeId) 
      ? values.registrationFeeId 
      : [values.registrationFeeId]
    const totalAmount = feeIds.reduce((sum, feeId) => {
      const fee = fees.find((f) => f.id === feeId) as Fee
      return sum + (fee?.unitPrice || 0)
    }, 0)
    
    let fee: any = []
    
    if (yBZFRegister) {
      const data = fees.filter((f) => feeIds.includes(f.id))?.map((v) => ({ ...v, hilistCode: '' } as Fee))
      fee = data
    } else {
      const data = fees.filter((f) => feeIds.includes(f.id))?.map((v) => ({ ...v} as Fee))
      fee = data  
    }
    registration.receiveInAdvance =
      totalAmount > 0 ? (values.receiveInAdvance ? 1 : 0) : 0
    
    // 检查所有选择费用的hilistCode是否都等于空或null
    const isZFRegister = feeIds.every(feeId => {
      const feeItem = fees.find((f) => f.id === feeId) as Fee
      return !feeItem?.hilistCode || feeItem?.hilistCode == ''
    }) || yBZFRegister

    if (
      apiUserType !== 'SYLD' &&
      values.receiveInAdvance &&
      fee && isZFRegister &&
      !params &&
      totalAmount > 0
    ) {
      // 自费挂号弹框revertPage
      registerPayment(values)
    } else {
      // 包含聚合支付就打开遮罩层
      if (
        params?.payMethod?.split(',')?.find((v: any) => {
          return v == 2
        })
      ) {
        setShowJHZFAction(true)
      }
      dispatch(
        register({
          patient,
          fee,
          payment: params,
          patientInsurance: patientInsuranceItem,
          registration,
        })
      )
        .then(unwrapResult)
        .then((data: any) => {
          //三医联动挂号，弹出对方的挂号页
          if(apiUserType === 'SYLD'){
            const optId = data?.registrationId
            const psnId = data?.patientId
            setUrl(window.location.origin+"/ehis/h5/checkbeforething.html?type=1&id="+optId+"&psn_id="+psnId+"&mdtrt_cert_type="+mdtrt_cert_type+"&mdtrt_cert_no="+url_param);
            setLoading(true);
            setIsOpen(true);
            messageWrapFn = (event: MessageEvent) => syldRegistrationListener(event, optId);
            // 父页面监听子iframe消息
            window.addEventListener('message', messageWrapFn);
            return;
          }


          setShowJHZFAction(false)
          setRegisterData(data)
          dispatch(setAppointmentIdSlice(''))
          notification.success({
            message: '挂号成功!',
            duration: 3,
          })
          setDepartmentDoctorMessage()
          localStorage.removeItem('appointFlag')
          setYBZFRegister(false)
          setInsuranceItem(insuranceItem)
          setSkipPrintingFlag(false)
          sessionStorage.removeItem('TRIAGEPATIENTINFO')
          const registrationCharge = localStorage.getItem('registrationCharge')
          if (registrationCharge == 'false' && !values.skipPrinting) {
            setRegistrationId(String(data?.registrationId))
            setPrintPaymentId(String(data?.paymentId))
            setPrintTreatmentId(String(data?.treatmentId))
          }

          //有聚合支付时
          const payMethodList = data?.payment?.payMethod?.split(',')
          if (
            payMethodList?.find((v: any) => {
              return v == 2
            })
          ) {
            setJuheIptShow(true)
            setPayCode('')
          } else {
            //医保支付时
            if (
              insuranceItem?.insuranceCode &&
              !isZFRegister &&
              totalAmount > 0
            ) {
              setShowStopAction(true)
              //江苏的异地，需要传一个固定的2203诊断（健康查体）后才可以结算挂号费
              if (
                values.receiveInAdvance &&
                !isZFRegister &&
                String(tenantAreaCd).slice(0, 4) !=
                patientInsurance.insuranceRegion.slice(0, 4) &&
                insuranceItem?.insuranceCode == 'JIANGSU'
              ) {
                DefaultMdtrtinfoUp('requestString', data, values)
              } else {
                FeeListUp('requestString', data, values)
              }
            } else {
              if (!values.skipPrinting) {
                setSkipPrintingFlag(true)
              } else {
                if (query.has('redirect') && ((values.skipPrinting || insuranceItem?.insuranceCode) && data.registrationId > 0)) {
                  dispatch(
                    traceRoute({
                      name: '医生门诊',
                      path: '/treatment',
                      query: `registrationId=${data?.registrationId}`,
                    })
                  )
                }
                revertPage()
              }

            }
          }


          setQrCode('')
          setChnlid('')
          onSuccess && onSuccess()
          // if (location?.state?.backHome) {
          //   history.go(-1)
          // }


        })
        .catch(() => {
          setLoading(false)
          setRegisterLoading(false)
        })
    }
  }
  let messageWrapFn:any = null;

  const syldRegistrationListener = (event:MessageEvent,optId:string) =>{
    // 获取子页面传过来的完整对象
    const resData = event.data;
    // 判断消息类型匹配关闭iframe
    if (resData.type !== 'CLOSE_IFRAME') return;

    console.log('resData',resData);
    // 取出payload
    const payload = resData?.payload;
    const status = payload?.status;  //状态
    const reason = payload?.reason; //失败原因
    const data = payload?.data; //数据

    // 读取所有业务字段
    const mdtrt_id = data?.mdtrt_id;        // 就诊ID
    const pool_pay = data?.pool_pay;        // 统筹金额
    const setl_sn = data?.setl_sn;          // 结算流水号
    const total_fee = data?.total_fee;      // 总金额
    const ybjj_pay = data?.ybjj_pay;         // 医保支付金额

    console.log('结算状态：', status);
    console.log('就诊ID：', mdtrt_id);
    console.log('结算流水：', setl_sn);
    console.log('总费用：', total_fee);
    console.log('统筹支付：', pool_pay);
    console.log('医保基金支付：', ybjj_pay);

    // 业务逻辑：成功后关闭iframe
    if (status === 'success' || status === '1') {
      setLoading(true)
      setRegisterLoading(true)
      dispatch(
        openRegisterForSyldAsync({
          mdtrt_id:mdtrt_id,
          registrationId:optId
        })
      )
        .then(unwrapResult)
        .then((data: any) => {
          notification.success({
            message: '挂号成功!',
            duration: 3,
          })
          revertPage()
          setQrCode('')
          setChnlid('')
        })
        .catch((e) => {
          notification.success({
            message: 'SYLD-挂号失败!'+e.message,
            duration: 3,
          })
          setLoading(false)
          setRegisterLoading(false)
        }).finally(() => {
          window.removeEventListener('message', messageWrapFn);
          // setTimeout(() => {
            setIsOpen(false);
            setLoading(false)
            setRegisterLoading(false)
          // }, 800)

        })

    }else{
      notification.error({
        message: 'SYLD-挂号失败!'+reason,
        duration: 3,
      })
      setIsOpen(false);
    }
  }


  const getResiterMedicalNum = () => {
    dispatch(getMedicalNum())
      .then(unwrapResult)
      .then((res) => {
        setReatmentNum(res)
        // form.setFieldsValue({
        //   treatmentNo: res,
        // })
      })
  }

  useEffect(() => {
    getResiterMedicalNum()
    let timer: any = null
    timer = setInterval(() => {
      getResiterMedicalNum()
    }, 5000)
    return () => {
      timer && clearInterval(timer)
    }
  }, [dispatch])

  // 获取患者特慢病信息
  const searchMedical = (
    res: any,
    serverType: any,
    responseString?: string
  ) => {
    //三医联动不做触发
    if(apiUserType === 'SYLD'){
      return;
    }
    dispatch(
      searchQueryPsnAsync({
        serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          insuplcAdmdvs: res?.insuranceRegion,
          psnNo: res?.ybPersonalNo,
          // 测试代码
          // insuplcAdmdvs: '330599',
          // psnNo: '33050099000010000000525114',
        },
      }) as any
    )
      .then(unwrapResult)
      .then(async (result: any) => {
        if (serverType === 'requestString') {
          const data = strParse(result)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              noSuccess: true,
            },
            (call: any) => {
              searchMedical(res, 'response', JSON.stringify(call.netmessage))
            }
          )
        }
      })
  }

  // 电子凭证读卡
  const readEType = () => {
    readCardEHttp(
      {
        trade_args: [
          insuranceItem.countryHospitalNb,
          '01301',
          faceAuth ? 'cn.nhsa.ec.auth' : '',
          userId,
          userName,
          '',
          '',
        ],
      },
      (data, err) => {
        if (!err) {
          const infoList = data.netmessage.split('|')
          getIdCardInfo(infoList[1])
          form.setFieldsValue({
            idCardNumber: infoList[1],
            ybkh: infoList[1],
          })
          if (infoList[1]) {
            isAdultFn(infoList[1], '')
          }
          getPatientInfo(
            data.netmessage,
            data?.QrCode,
            data?.ChnlId,
            'requestString'
          )
        } else {
          setCardType('')
          setLoading(false)
          setRegisterLoading(false)
          setReadLoadingDzpz(false)
        }
        setFaceAuth(false)
      }
    )
  }

  const getInsuName = (insutype: any) => {
    switch (insutype) {
      case '310':
        return '职工基本医疗保险'
      case '390':
        return '城乡居民基本医疗保险'
      case '340':
        return '离休人员医疗保障'
      case '510':
        return '生育保险'
      default:
        return insutype
    }
  }
  // 实体卡读卡
  const readSType = () => {
    readCardSHttp(
      {
        trade_args: [getTradeCode(tenantAreaCd.slice(0, 4))],
      },
      (data, err) => {
        if (!err) {
          getPatientInfo(
            baseData?.insuranceCode == 'JIANGSU'
              ? data.netmessage
              : JSON.stringify(data.netmessage),
            data?.QrCode,
            data?.ChnlId,
            'requestString'
          )
          form.setFieldsValue({
            ybkh: data?.netmessage.CardNum,
            name: data?.netmessage.Name,
            idCardNumber: data?.netmessage.IDNum,
          })
          if (data?.netmessage.IDNum) {
            getIdCardInfo(data?.netmessage.IDNum)
            isAdultFn(data?.netmessage.IDNum, '')
          }
        } else {
          setCardType('')
          setLoading(false)
          setRegisterLoading(false)
          setReadLoadingStk(false)
        }
      }
    )
  }

  // 查询人员累计信息
  const searchPsnSum = (
    isShowModal: boolean,
    serverType: serverType,
    psnNo: string,
    insuranceRegion: string,
    responseString?: string
  ) => {
    //三医联动不做触发
    if(apiUserType === 'SYLD'){
      return;
    }
    dispatch(
      searchPsnSumAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          psnNo,
          insuranceRegion,
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              message: '人员累计信息查询',
            },
            (call: any, err) => {
              if (!err) {
                searchPsnSum(
                  isShowModal,
                  'response',
                  psnNo,
                  insuranceRegion,
                  JSON.stringify(call.netmessage)
                )
              } else {
                setSearchPsnSumDisabled(false)
              }
            }
          )
        } else {
          const obj: otherPatientInsuranceItemParams = {}
          if (isShowModal) {
            setSumVisible(true)
            setSumList(res)
          }
          const again = res?.currYearInsCumWithoutYear.filter((v: any) => {
            return (
              v.name === '大病补充起付金额累计' ||
              v.name === '门诊起付金额累计' ||
              v.name === '门诊慢病起付金额累计' ||
              v.name.indexOf('统筹基金累计') >= 0
            )
          })

          again.forEach((v: any) => {
            if (v.name === '大病补充起付金额累计') {
              obj.dbbcqflj = v.cum
            } else if (v.name === '门诊起付金额累计') {
              obj.dnqfxljPt = v.cum
            } else if (v.name === '门诊慢病起付金额累计') {
              obj.dnqfxljMb = v.cum
            } else if (v.name.indexOf('统筹基金累计') >= 0) {
              setTongchouLJ(v.cum)
            }
          })
          setOtherPatientInsuranceItem(obj)
          setSearchPsnSumDisabled(false)
        }
      })
      .catch(() => {
        setSearchPsnSumDisabled(false)
      })
  }


  useEffect(() => {
    //三医联动令牌的机构，直接调用简易HIS的读卡函数
    if(apiUserType === 'SYLD'){
      if (cardType == 1) {
        setOtherPatientInsuranceItem({}) // 防止误用他人信息
        readCardRef.current.blur() //按钮失焦，防止重复点击
        // const readType = form.getFieldsValue().readType
        success('读卡中', 1)
        handleReadPsn(faceAuth?'face':'ec')
      } else if (cardType == 2) {
        setOtherPatientInsuranceItem({}) // 防止误用他人信息
        readCardRef.current.blur() //按钮失焦，防止重复点击
        // const readType = form.getFieldsValue().readType
        success('读卡中', 2)
        const idCardNumber = form.getFieldsValue().idCardNumber
        if (idCardNumber) {
          handleReadPsn('idcard')
        } else {
          notification.info({
            message: '请输入身份证号',
          })
        }
      } else if (cardType === 3) {
        setOtherPatientInsuranceItem({}) // 防止误用他人信息
        readCardRef.current.blur() //按钮失焦，防止重复点击
        // const readType = form.getFieldsValue().readType
        success('读卡中', 3)
        handleReadPsn('card')
      }
    }else{
      if (cardType == 1) {
        setOtherPatientInsuranceItem({}) // 防止误用他人信息
        readCardRef.current.blur() //按钮失焦，防止重复点击
        // const readType = form.getFieldsValue().readType
        success('读卡中', 1)
        readEType()
      } else if (cardType == 2) {
        setOtherPatientInsuranceItem({}) // 防止误用他人信息
        readCardRef.current.blur() //按钮失焦，防止重复点击
        // const readType = form.getFieldsValue().readType
        success('读卡中', 2)
        const idCardNumber = form.getFieldsValue().idCardNumber
        if (idCardNumber) {
          getPatientInfo(idCardNumber, '0', '0', 'requestString')
        } else {
          notification.info({
            message: '请输入身份证号',
          })
        }
      } else if (cardType === 3) {
        setOtherPatientInsuranceItem({}) // 防止误用他人信息
        readCardRef.current.blur() //按钮失焦，防止重复点击
        // const readType = form.getFieldsValue().readType
        success('读卡中', 3)
        readSType()
      }
    }
  }, [cardType])

  // 获取参保人信息
  const getPatientInfo = (
    fullCardInfo: string,
    qrcode: string,
    chnlid: string,
    serverType: any,
    responseString?: string
  ) => {
    setYBZFRegister(false)
    setFullCardInfo(fullCardInfo)
    setQrCode(qrcode)
    setChnlid(chnlid)
    dispatch(
      getPatientInfoAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          cardType: String(cardType) == "11" ? '1' : String(cardType),
          fullCardInfo,
          qrcode: qrcode,
          chnlid: chnlid,
          otherMap: {},
        },
      })
    )
      .then(unwrapResult)
      .then(async (res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call: any, err) => {
              if (!err) {
                success('正在获取人员信息', cardType)
                //这里可能出现多个参保险种，需要机构自行选择一个
                //逻辑放后端了
                // const list = call?.netmessage?.output?.insuinfo;
                // if(Array.isArray(list) && list.length>1){
                //   setXianzhongList([]);
                //   setXianzhongList(list);
                //   setXianzhongVisible(true)
                //   return;
                // }else{
                getPatientInfo(
                  fullCardInfo,
                  qrcode,
                  chnlid,
                  'response',
                  JSON.stringify(call.netmessage)
                )
                // }
              } else {
                setCardType('')
                setReadLoadingDzpz(false)
                setReadLoadingStk(false)
                setReadLoadingSfz(false)
              }
            }
          )
        } else {
          successMessage('读卡成功')
          setReadLoadingDzpz(false)
          setReadLoadingStk(false)
          setReadLoadingSfz(false)
          setSkipPrintingFlag(false)
          setPatientInsurance(res?.patientInsurance)
          setAllLableNameList(res?.patientInfo?.labels?.length ? res?.patientInfo?.labels : [])
          setLableNameList(res?.patientInfo?.labels?.length ? res?.patientInfo?.labels?.slice(0, 5) : [])
          setSameDayRegistrationFee(
            res?.patientInsurance?.sameDayRegistrationFee
          )
          setTradeCntInfo(res?.cntBean);//保存结算次数信息

          if (
            res?.patientInsurance.patientId &&
            res?.patientInsurance.patientId != -1
          ) {
            dispatch(getTreatmentNotice(res?.patientInsurance.patientId))
              .then(unwrapResult)
              .then((notice) => setNotice(notice))
              .catch(() => {
                // do nothing
              })
            isSee(res?.patientInsurance.patientId)
          }
          searchMedical(res?.patientInsurance, 'requestString') //查询特慢病信息
          if (
            insuranceItem?.insuranceCode == 'ZHEJIANG' ||
            insuranceItem?.insuranceCode == 'JIANGSU'
          ) {
            //重庆不查累计
            searchPsnSum(
              false,
              'requestString',
              res?.patientInsurance?.ybPersonalNo,
              res?.patientInsurance?.insuranceRegion
            )
          }

          form.setFieldsValue({
            // ybkh: res?.patientInsurance.CardNum,
            name: res?.patientInsurance.name,
            idCardNumber: res?.patientInsurance.idCard,
            cbxzmc: res?.patientInsurance.cbxzmc,
            memberTypemc: res?.patientInsurance.memberTypemc,
            extraPeopleTypemc: res?.patientInsurance.extraPeopleTypemc,
            emergencyContactName: res?.patientInsurance.emergencyContactName,
            emergencyContactPhone: res?.patientInsurance.emergencyContactPhone,
            treatmentStatusmc: res?.patientInsurance.treatmentStatusmc,
            zhye: res?.patientInsurance.zhye,
            dnzhye: res?.patientInsurance.dnzhye,
            lnzhye: res?.patientInsurance.lnzhye,
            companyName: res?.patientInsurance.brdw,
            ybPersonalNo: res?.patientInsurance.ybPersonalNo,
            phone: res?.patientInsurance.phone,
            sex: Number(res?.patientInsurance.sex),
            address: res?.patientInsurance.address,
            remark: res?.patientInfo?.remark,
            nation: res?.patientInsurance?.naty,
          })
          isAdultFn(res?.patientInsurance.idCard, '')
          if (res?.patientInfo?.id && res?.patientInfo?.id > 0) {
            setPatientId(res?.patientInfo?.id)
          }
          if (res?.patientInsurance.idCard) {
            getIdCardInfo(res?.patientInsurance.idCard)
          }
          if (
            res?.patientInsurance?.birthday &&
            res?.patientInsurance?.idCard?.length < 15
          ) {
            updateYearsAndMonths(res?.patientInsurance?.birthday)
          }
          //根据地区，重新设置卡串（部分地区没有卡串，需要人工造）
          refreshFullCardInfo(res?.patientInsurance, String(cardType))
        }
      })
      .catch((ex) => {
        notification.error({
          message: ex.message,
          duration: 3,
        })
        setCardType('')
        setReadLoadingDzpz(false)
        setReadLoadingStk(false)
        setReadLoadingSfz(false)
      })
  }
  const refreshFullCardInfo = (patientInsurance?: any, cardType?: string) => {
    const tradeType = getTradeName()
    //重庆需要手动封装卡串
    if (tradeType === 'CQ_ZHYB') {
      let fci = ''
      // 唐雅兴|340826199312013449|01|330000ecpa8m5er05t138fab0a00008cec9ef2|330108|
      // {"CanOpen":true,"CardIDCode":"330100D1560000050154217FE5EC1421","CardNum":"F1056831X","CardType":"3","Gender":"","IDNum":"330126196402050012","Name":"陈雪林","PsamTN":"330800812222","Success":true,"flag":"1","ylbxtcqbm":"330100"}
      //电子凭证
      if (cardType === '1') {
        fci =
          patientInsurance?.name +
          '|' +
          patientInsurance?.idCard +
          '|01|' +
          patientInsurance?.ecToken +
          '|' +
          patientInsurance?.insuranceRegion
      } else {
        //实体卡
        const struct = {
          CanOpen: 'true',
          CardIDCode: '0',
          CardNum: patientInsurance?.medicalCardNo,
          CardType: '3',
          Gender: patientInsurance?.sex,
          IDNum: patientInsurance?.idCard,
          Name: patientInsurance?.name,
          PsamTN: '0',
          Success: true,
          flag: '1',
          ylbxtcqbm: patientInsurance?.insuranceRegion,
        }
        fci = JSON.stringify(struct)
      }
      setFullCardInfo(fci)
      setQrCode('0')
      setChnlid('0')
    }
    //其他地区不变
  }
  const normalMsg = (str: string) => {
    const hide = message.loading(str, 0)
    setTimeout(() => {
      hide()
    }, 3000)
  }
  // 2203 (默认诊断信息上传，一般用于江苏异地挂号费收费时，医保要求必须传一个诊断）
  const DefaultMdtrtinfoUp = (
    serverType: any,
    treatmentData: registerValue,
    values: Record<string, unknown>,
    responseString?: string,
    resolve?: any,
    reject?: any
  ) => {
    dispatch(
      MdtrtinfoUpAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...baseData,
            responseString: responseString ? responseString : undefined,
          },
          exp_content: '',
          treatmentId: treatmentData?.treatmentId,
          registerFlag: 1
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          normalMsg('正在上传诊断')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                setLoading(false)
              } else {
                DefaultMdtrtinfoUp('response', treatmentData, values, JSON.stringify(call.netmessage))
              }
            },
            undefined,
            reject
          )
        } else {
          messageNotification('诊断上传完毕')
          FeeListUp('requestString', treatmentData, values)
          resolve && resolve()
        }
      })
      .catch((err: any) => {
        setLoading(false)
        reject && reject()
      })
  }
  const messageNotification = async (str: string) => {
    await message.destroy()
    notification.success({
      message: str,
      duration: 1,
    })
  }
  // 2204
  const FeeListUp = (
    serverType: serverType,
    treatmentData: registerValue,
    values: Record<string, unknown>,
    responseString?: string
  ) => {
    dispatch(
      FeeListUpAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          exp_content: '',
          treatmentId: treatmentData?.treatmentId,
          registerFlag: 1,
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          success('正在上传费用', cardType)
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '费用上传',
            },
            (call, err) => {
              if (err) {
                setShowStopAction(false)
                setReadLoadingDzpz(false)
                setReadLoadingSfz(false)
                setReadLoadingStk(false)
              } else {
                FeeListUp(
                  'response',
                  treatmentData,
                  values,
                  JSON.stringify(call.netmessage)
                )
              }
            },
            undefined
          )
        } else {
          preSettlement('requestString', treatmentData, values)
        }
      })
  }

  // 2206
  const preSettlement = (
    serverType: serverType,
    treatmentData: registerValue,
    values: Record<string, unknown>,
    responseString?: string
  ) => {
    dispatch(
      preSettlementAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          chrg_bchno: '2',
          exp_content: '',
          treatmentId: treatmentData?.treatmentId,
          patientId: String(treatmentData?.patientId),
          registrationId: String(treatmentData?.registrationId),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          success('正在挂号费预结算', cardType)
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                setReadLoadingDzpz(false)
                setReadLoadingSfz(false)
                setReadLoadingStk(false)
                setReadLoadingRl(false)
                setShowStopAction(false)
              } else {
                preSettlement(
                  'response',
                  treatmentData,
                  values,
                  JSON.stringify(call.netmessage)
                )
              }
            }
          )
        } else {
          registerPayment(values, res, treatmentData.recipeId)
        }
      })
      .catch(() => {
        setReadLoadingDzpz(false)
        setReadLoadingSfz(false)
        setReadLoadingStk(false)
        setReadLoadingRl(false)
        setShowStopAction(false)
      })
  }

  // 2207
  const saveSettlement = (
    serverType: serverType,
    treatmentData?: registerValue,
    params?: PaymentRegistrationParams,
    responseString?: string
  ) => {
    dispatch(
      saveSettlementAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          chrg_bchno: '2',
          exp_content: '',
          treatmentId: treatmentData?.treatmentId,
          patientId: String(treatmentData?.patientId),
          registrationId: String(treatmentData?.registrationId),
          doPayVO:
            serverType === 'requestString'
              ? { ...params, insuranceTradeId: '', settlementCategory: 1 }
              : undefined,
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          success('门诊结算中', cardType)
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
            },
            (call) => {
              saveSettlement(
                'response',
                treatmentData,
                params,
                JSON.stringify(call.netmessage)
              )
            }
          )
        } else {
          doPay(params, res.insuranceTradeId)
          // messageNotification('结算成功')
        }
      })
  }

  const doPay = (params: any, insuranceTradeId?: string) => {
    dispatch(pay({ ...params, insuranceTradeId, settlementCategory: 1 }))
      .then(unwrapResult)
      .then((v: any) => {
        notification.success({
          message: '挂号费支付成功',
          duration: 1.5,
        })
        setIsModalVisible(false)
      })
      .catch(() => {
        notification.info({
          message: '可以到待收费页面中继续收挂号费',
          duration: 1.5,
        })
        setIsModalVisible(false)
      })
  }

  useEffect(() => {
      dispatch(getFeeList(insuranceItem?.insuranceCode))
    // getResiterMedicalNum()
  }, [dispatch, insuranceItem])

  // 历史患者/患者姓名搜索
  useEffect(() => {
    if (source === 0) {
      dispatch(getPatientList(keyword || keywords, 30))
    } else if (source === 1) {
      dispatch(getTriageHistorylist({ name: keyword || keywords, size: 10 }))
        .then(unwrapResult)
        .then((v: any) => {
          setList(v?.records)
        })
    }
  }, [dispatch, keyword, keywords, source])

  useEffect(() => {
    if (patient) {
      setLableNameList(patient?.labels?.length ? patient?.labels?.slice(0, 5) : [])
      setAllLableNameList(patient?.labels?.length ? patient?.labels : [])
    }
  }, [patient])

  useEffect(() => {
    if (patient && source === 0) {
      setPatientId(appointmentId ? patient?.patientId : patient.id)
      const isAgeBothZero = Number(patient?.ageYear) === 0 && Number(patient?.ageMonth) === 0
      form.setFieldsValue({
        ...patient,
        phone: patient?.phone ? (!GHCKHZSJHData ? getMaskPhone(patient?.phone) : patient?.phone) : '',
        emergencyContactPhone: patient?.emergencyContactPhone ? (!GHCKHZSJHData ? getMaskPhone(patient?.emergencyContactPhone) : patient?.emergencyContactPhone) : '',
        patientSource: patient?.patientSource ? (patient?.patientSource) : (getSourceName(patient?.source)),
        ageYear: isAgeBothZero ? '' : patient?.ageYear,
        ageMonth: isAgeBothZero ? '' : patient?.ageMonth,
        area:
          patient?.provinceCode && patient?.provinceCode != 0
            ? [
              Number(patient?.provinceCode),
              Number(patient?.cityCode),
              Number(patient?.contryCode),
            ]
            : [Number(provinceCode), Number(cityCode), Number(countyCode)],

        birthday: patient.birthday
          ? moment(patient.birthday).format(DateTimeFormatSimple)
          : '',
      })

      if (patient?.idCardNumber) {
        getIdCardInfo(patient?.idCardNumber)
      } else if (patient?.birthday) {
        updateYearsAndMonths()
      } else if (patient?.ageYear > 0 || patient?.ageMonth > 0) {
        // 没有身份证和生日时，根据已有年龄数据判断模式
        const totalMonths = (patient?.ageYear || 0) * 12 + (patient?.ageMonth || 0)
        if (totalMonths < 12 && totalMonths > 0) {
          setAgeUnit('month')
          form.setFieldsValue({
            ageMonth: totalMonths,
            ageDay: patient?.ageDay || 0,
          })
        } else if (totalMonths >= 12) {
          setAgeUnit('year')
        }
      }
      setKeywords(patient.name)
      setPhoneInfo({
        phone: patient?.phone,
        emergencyContactPhone: patient?.emergencyContactPhone,
        phoneDisabled: patient?.phone && !GHCKHZSJHData,
        emergencyContactPhoneDisabled: patient?.emergencyContactPhone && !GHCKHZSJHData,
        phoneHover: false,
        emergencyContactPhoneHover: false,
      })
      dispatch(setPatient(undefined))

    } else if (triageDetail && source === 1) {
      setTriageDetailId(triageDetail.id)
      setKeywords(triageDetail.patientName)
      const triageAge = triageDetail.age || 0
      const isTriageAgeBothZero = Number(triageDetail?.age) === 0 && Number(triageDetail?.ageMonth) === 0
      form.setFieldsValue({
        ...triageDetail,
        area:
          triageDetail?.provinceCode && triageDetail?.provinceCode != 0
            ? [
              Number(triageDetail?.provinceCode),
              Number(triageDetail?.cityCode),
              Number(triageDetail?.contryCode),
            ]
            : [],
        name: triageDetail.patientName,
        age: isTriageAgeBothZero ? '' : triageAge,
        ageYear: isTriageAgeBothZero ? '' : triageAge,
        ageMonth: isTriageAgeBothZero ? '' : triageDetail?.ageMonth,
        idCardNumber: triageDetail.identityCard,
        birthday: triageDetail.birthday
          ? moment(triageDetail.birthday).format(DateTimeFormatSimple)
          : '',
      })
      isAdultFn(triageDetail.identityCard, triageDetail.birthday
        ? moment(triageDetail.birthday).format(DateTimeFormatSimple)
        : '')
      if (triageDetail?.idCardNumber) {
        getIdCardInfo(triageDetail?.idCardNumber)
      } else if (triageDetail?.birthday) {
        updateYearsAndMonths()
      } else if (triageAge > 0 && triageAge < 1) {
        // 分诊年龄 < 1 岁，切换到月/天模式
        setAgeUnit('month')
        form.setFieldsValue({ ageMonth: 0, ageDay: 0 })
      }
      setTriageDetail(undefined)
      setIsPatientOverlayVisible(false)
      setIsPatientNameOverlayVisible(false)
    }
  }, [dispatch, patient, triageDetail])

  useEffect(() => {
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    } else {
      dispatch(setInsurance({}))
    }
  }, [insuranceItem])

  // useEffect(() => {
  //   return () => {
  //     clearTimeout()
  //   }
  // }, [])
  const getTodayPage = (name: string) => {
    dispatch(
      getToDayListPage({
        keyword: name || '',
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setToDayList(res)
      })
  }
  useEffect(() => {
    if (!menus.length) return
    const status = menus.some((item: any) => item.name === '预约')
    status && getTodayPage('')
    setIsShowToDay(status)
  }, [menus])

  const cancelForm = () => {
    sessionStorage.removeItem('TRIAGEPATIENTINFO')
    setDiabled(false)
    setTradeCntInfo({})
    setRegisterLoading(false)
    setSameDayRegistrationFee('')
    setKeyword('')
    setKeywords('')
    dispatch(setAppointmentIdSlice(''))
    setPatientId('')
    setTriageDetailId('')
    setPatientInsurance({})
    setPatientInfo({})
    setYBZFRegister(false)
    setIsAdult(false)
    setAllLableNameList([])
    setLableNameList([])
    const vs = form.getFieldsValue()
    form.resetFields()
    setIdCardInputValid(false)
    setWatchedAdvance(false)
    form.setFieldsValue({
      area: provinceCode ? [provinceCode, cityCode, countyCode] : [],
      sex: HZXB,
    })
    setDefaultPatientSource();
    setOweMoneyNumShow(false) //欠费金额是否显示
    getResiterMedicalNum()
    if (isHisCode) {
      form.setFieldsValue({
        registrationCategory: insuranceItem,
        readType: vs.readType,
      })
    }
    setHasCard(false)
    setSumList({})
    if (atDoctor == 1 || atDoctor == 2) {
      // 偏好为 '选中上一次挂号医生'
      if (
        checkDepartment(storageDepartmentId)
      ) {
        if (atDoctor == 1) {
          form.setFieldsValue({
            registrationDepartmentId: storageDepartmentId,
          })
          setDoctors([])
          getDoctorListInDepartment(storageDepartmentId)
        } else if (atDoctor == 2) {
          getDoctorListInDepartment(localDepartmentId)
          if (checkDepartment(localDepartmentId)) {
            form.setFieldsValue({
              registrationDepartmentId: localDepartmentId,
            })
          }
          if (checkDoctor(localDoctorId)) {
            form.setFieldsValue({ registrationDoctorId: localDoctorId })
          }
        }
      }
    } else if (atDoctor == 3) {
      // 偏好为 '选中当前帐号医生'
      getDoctorListInDepartment(departmentId)
      form.setFieldsValue({ registrationDepartmentId: departmentId })
      if (checkDoctor(userId)) {
        form.setFieldsValue({ registrationDoctorId: userId })
      }
    }
  }

  const getDoctorListInDepartment = (departmentId: any) => {
    dispatch(getDoctorsInDepartmentListAsync({ departmentId: departmentId }))
      .then(unwrapResult)
      .then((v: any) => {
        dispatch(getDoctorsInDepartmentTimeListAsync())
          .then(unwrapResult)
          .then((val) => {
            const list = _.chain(v.records)
              .map((u) => U.fromJson(u))
              .value()
            const doctorList = list
              ?.map((n: any) => {
                const lastRegTime = val?.find((item: any) => item.doctorId == n.id)?.lastRegTime
                const time = lastRegTime
                  ? Math.floor((Date.now() - new Date(lastRegTime).getTime()) / (1000 * 60))
                  : null
                return {
                  ...n,
                  lastRegTime: tenantCategory == 16 ? (time && time <= 120 ? time : '') : '',
                }
              })
            // 按 lastRegTime 分钟数升序排序
            const hasLastRegTime = doctorList.filter((item: any) => item.lastRegTime).sort((a, b) => {
              const aTime = a.lastRegTime ?? Infinity
              const bTime = b.lastRegTime ?? Infinity
              return bTime - aTime
            })
            const notHasLastRegTime = doctorList.filter((item: any) => !item.lastRegTime)?.map((e: any) => ({
              ...e,
              namePY: pinyin(e.realname, {
                pattern: 'first',
                toneType: 'none',
                separator: '',
              }).toUpperCase()
            }))
              .sort((a: any, b: any) => a.namePY.localeCompare(b.namePY, 'zh-CN')) // 按姓名字母顺序 a在前
            setDoctors([...notHasLastRegTime, ...hasLastRegTime])
          })
      })
  }

  useEffect(() => {
    getTreatmentAssistantDoctorFn()
  }, [dispatch, tenantCategory])

  // 获取助理医师
  const getTreatmentAssistantDoctorFn = () => {
    dispatch(
      getCounselor({
        current: 1,
        size: 100,
        stationCategory: 8,
      })
    )
      .then(unwrapResult)
      .then(({ records }) => {
        dispatch(getCounselorListTimePage())
          .then(unwrapResult).then((val) => {
            const list = records
              .filter((v: any) => v.kssxbz != 1)
              .filter((v: any) => v.state == 1)
            // 根据返回的list中的id匹配，把第二个接口返回的time字段合并进去
            const enrichedList = list
              ?.map((v: any) => {
                const lastRegTime = val?.find((item: any) => item.doctorId == v.id)?.lastRegTime
                const time = lastRegTime
                  ? Math.floor((Date.now() - new Date(lastRegTime).getTime()) / (1000 * 60))
                  : null
                return {
                  ...v,
                  lastRegTime: tenantCategory == 16 ? (time && time <= 120 ? time : '') : '',
                }
              })
            // 按 lastRegTime 分钟数升序排序，null/空 视为最大排最后
            const hasLastRegTime = enrichedList?.filter((item: any) => item.lastRegTime).sort((a: any, b: any) => {
              const aTime = a.lastRegTime ?? Infinity
              const bTime = b.lastRegTime ?? Infinity
              return bTime - aTime
            })
            const notHasLastRegTime = enrichedList
              ?.filter((item: any) => !item.lastRegTime)
              ?.map((e: any) => ({
                ...e,
                namePY: pinyin(e.realname, {
                  pattern: 'first',
                  toneType: 'none',
                  separator: '',
                }).toUpperCase()
              }))
              .sort((a: any, b: any) => a.namePY.localeCompare(b.namePY, 'zh-CN')) // 按姓名字母顺序 a在前
            setTreatmentAssistantDoctorList([...notHasLastRegTime, ...hasLastRegTime])
          })
      }
      )
  }

  useEffect(() => {
    //获取省市数据
    dispatch(getAddress())
      .then(unwrapResult)
      .then((res: any) => {
        setAllList(res)
      })
  }, [])

  const provinceCode = credentials?.tenantProvinceCode
    ? Number(credentials?.tenantProvinceCode + '000000')
    : ''
  const cityCode = credentials?.tenantCityCode
    ? Number(credentials?.tenantCityCode + '000000')
    : ''
  const countyCode = credentials?.tenantCountyCode
    ? Number(credentials?.tenantCountyCode + '000000')
    : ''
  useEffect(() => {
    form.setFieldsValue({
      area: provinceCode ? [provinceCode, cityCode, countyCode] : [],
    })
  }, [])

  // 设置默认患者来源的独立函数
  const setDefaultPatientSource = () => {
    // 安全获取sourceList，提供空数组默认值
    const sourceList = classificationList?.sourceList || [];

    let patientSourceValue = '';
    // HZLY患者来源 先从接口获取，如果没有优先patientSource 其次再走 source（数字类型，需要转换）
    if (HZLY) {
      // 使用已导入的 getSourceTypeName 函数进行转换
      patientSourceValue = HZLY;
    }
    // 如果都没有数据，使用第一个选项
    else if (sourceList?.length > 0) {
      patientSourceValue = sourceList[0]?.name || '';
    }
    // 设置表单值
    if (patientSourceValue) {
      form.setFieldsValue({ patientSource: patientSourceValue });
    }
  };

  useEffect(() => {
    if (!settingOptionsVisible) {
      dispatch(getPatientOptionsAsync({ types: '0,1,2' }))
        .then(unwrapResult)
        .then((res: any) => {
          const findItems = (type: string) => {
            return res ? res?.find((t: any) => t.type == type)?.items?.map((v: any) => {
              return {
                name: v.context,
                value: v.sortNo,
              }
            }) : []
          }
          const sourceList = findItems('1');
          setClassificationList({
            sourceList: sourceList,
          });
        })
    }
  }, [settingOptionsVisible])

  // useEffect(() => {
  //   const isPageRefreshed = window.performance.navigation.type === 1
  //   if (isPageRefreshed) {
  //     // 清空localStorage中的数据
  //     localStorage.removeItem('appointFlag')
  //   }
  // }, [])

  // 获取字段是否必填
  useEffect(() => {
    dispatch(getFieldSettingList({
      functionType: 2,
      templateType: hisVersion == 1 ? 'KQHZSZ' : 'HZSZ',
    }))
      .then(unwrapResult)
      .then((res: any) => {
        const data = res?.[0]?.fields || []
        setFieldSettingList(data);
      })
  }, [])

  return (
    <Col
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {/* 今日预约 */}
      <div style={{ display: isShowToDay ? 'block' : 'none' }}>
        <div
          ref={appointmentRef}
          style={{
            marginRight: isShowModal ? '270px' : '0',
            marginBottom: isShowModal ? '90px' : '0',
          }}
          className={styles.toDayConsultContainer}
          onMouseDown={(e) => {
            if (isShowModal) return
            const currentPosition = e.pageY
            const bottom =
              document.body.clientHeight -
              appointmentRef.current!.offsetTop -
              120
            const currentBottom = bottom < 0 ? 0 : bottom
            function mouseMove(ev: any) {
              const offectY = currentPosition - ev.pageY
              appointmentRef.current!.style.bottom =
                currentBottom + offectY + 'px'
              toDayConsultRef.current!.style.bottom =
                currentBottom + offectY + 'px'
            }
            document?.addEventListener('mousemove', mouseMove)
            appointmentRef.current?.addEventListener('mouseleave', () => {
              document?.removeEventListener('mousemove', mouseMove)
            })
            toDayConsultRef.current?.addEventListener('mouseleave', () => {
              document?.removeEventListener('mousemove', mouseMove)
            })
            document?.addEventListener('mouseup', () => {
              document?.removeEventListener('mousemove', mouseMove)
            })
            appointmentRef.current?.addEventListener('mouseup', () => {
              document?.removeEventListener('mousemove', mouseMove)
            })
            toDayConsultRef.current?.addEventListener('mouseup', () => {
              document?.removeEventListener('mousemove', mouseMove)
            })
          }}
        >
          <div
            className={styles.consult}
            onClick={() => setIsShowModal(!isShowModal)}
          >
            <span>今</span>
            <span>日</span>
            <span>预</span>
            <span>约</span>
          </div>
        </div>
        <div
          ref={toDayConsultRef}
          className={styles.modal}
          style={{ display: isShowModal ? 'block' : 'none' }}
        >
          <Input
            maxLength={20}
            size='middle'
            placeholder='患者姓名/手机号'
            allowClear
            prefix={<SearchOutlined />}
            onChange={(e) => {
              const { value } = e.target
              getTodayPage(value)
            }}
          />
          <div className={styles.listWrap}>
            {toDayList &&
              toDayList.map((item: any) => {
                return (
                  <div className={styles.contentWrap} key={item.id}>
                    <div className={styles.contentName}>
                      <div>
                        <span
                          style={{ width: '60px', display: 'inline-block' }}
                        >
                          {item.name}
                        </span>
                        <Tag
                          style={{
                            color: '#fff',
                            background:
                              item.receiveTag == 0 ? '#ffb453' : '#17cd16',
                          }}
                        >
                          {item.receiveTag == 0 ? '初诊' : '复诊'}
                        </Tag>
                      </div>
                      <Button
                        size='small'
                        type='primary'
                        onClick={() => {
                          dispatch(setAppointmentIdSlice(item.id))
                        }}
                      >
                        去挂号
                      </Button>
                    </div>
                    <div>{`${item.appointmentStartTime}~${item.appointmentEndTime}  ${item.appointmentDepartmentName}`}</div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
      {/* <Row
        style={{
          height: '5rem',
          borderRadius: theme.br,
          backgroundColor: theme.pn,
          padding: '0 30px',
        }}
        align='middle'
        wrap={false}
        className={styles.bar}
      >
        <Label label='历史患者搜索' style={{ marginLeft: 30 }} />
        <Dropdown
          overlay={source === 0 ? patientOverlay : taiagelistOverlay}
          visible={isPatientOverlayVisible}
          disabled={hasCard}
          // onVisibleChange={(v) => setIsPatientOverlayVisible(v)}
        >
          <Input
            allowClear
            placeholder={
              source === 0 ? '姓名/性别/手机号/就诊卡号' : '姓名/性别/手机号'
            }
            prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
            value={keyword}
            onFocus={() => {
              if (source === 0) {
                dispatch(getPatientList(keyword))
                setSource(0)
              } else if (source === 1) {
                dispatch(getTriageHistorylist({ name: keyword, size: 10 }))
                  .then(unwrapResult)
                  .then((v: any) => {
                    setList(v?.records)
                  })
                setSource(1)
              }
              setIsPatientOverlayVisible(true)
              setIsPatientNameOverlayVisible(false)
            }}
            onBlur={() => {
              setTimeout(() => {
                setIsPatientOverlayVisible(false)
              }, 300)
            }}
            onClick={() => {
              setIsPatientOverlayVisible(true)
              setIsPatientNameOverlayVisible(false)
            }}
            onChange={(e) => {
              setIsPatientOverlayVisible(true)
              setIsPatientNameOverlayVisible(false)
              setKeyword(e.target.value)
              setKeywords('')
            }}
            style={{ width: '28rem', marginLeft: 40 }}
          />
        </Dropdown>
        <Col span={10} style={{ marginLeft: '20px' }}>
          <Radio.Group
            // defaultValue={source}
            value={source}
            onChange={(e: any) => {
              setSource(e.target.value)
              setDiabled(false)
              setAgeUnit('year')
              form.setFieldsValue({
                ageYear: '',
                age: '',
                ageMonth: '',
                ageDay: '',
                birthday: '',
                name: '',
                phone: '',
                idCardNumber: '',
                companyName: '',
                address: '',
                emergencyContactName: '',
                emergencyContactPhone: '',
                sex: 0,
                source: 0,
                patientId: '',
                area:[],
              })
              setKeywords('')
              setKeyword('')
            }}
          >
            <Radio value={0}>就诊患者</Radio>
            <Radio value={1}>预检分诊患者</Radio>
          </Radio.Group>
        </Col>
      </Row> */}
      <Form
        form={form}
        autoComplete='off'
        className={styles.form}
        colon={false}
        labelAlign='left'
        initialValues={{
          registrationCategory: RegistrationCategory.SelfPay,
          sex: Gender.Unknown,
          skipPrinting,
        }}
        onFinish={(val) => {
          const values = {
            ...val,
            phone: val?.phone == getMaskPhone(val?.phone) ? phoneInfo?.phone : val?.phone || '',
            emergencyContactPhone: val?.emergencyContactPhone == getMaskPhone(val?.emergencyContactPhone) ? phoneInfo?.emergencyContactPhone : val?.emergencyContactPhone || '',
          }
          if (values.registrationCategory) {
            if (yBZFRegister) {
              Modal.confirm({
                centered: true,
                title: '确认操作',
                width: 600,
                content: '确定要自费挂号吗？',
                okText: '确认',
                cancelText: '取消',
                icon: null,
                onCancel: () => {
                  setYBZFRegister(false)
                  setLoading(false)
                  setRegisterLoading(false)
                },
                onOk: () => {
                  enterLoading()
                  submit({ ...values, readType: String(cardType) })
                },
              })
            } else {
                if (hasCard) {
                  // 多选模式下，registrationFeeId可能是数组，计算所有选择费用的总和
                  const feeIds = Array.isArray(values.registrationFeeId)
                    ? values.registrationFeeId
                    : [values.registrationFeeId]
                  // const totalAmount = feeIds.reduce((sum, feeId) => {
                  //   const fee = fees.find((f) => f.id === feeId) as Fee
                  //   return sum + (fee?.unitPrice || 0)
                  // }, 0)

                  // 取第一个费用用于其他逻辑
                  const firstFeeId = feeIds[0]
                  const fee: any = fees.find(
                    (f) => f.id === firstFeeId
                  ) as Fee
                // if (
                //   values.receiveInAdvance &&
                //   fee?.hilistCode &&
                //   String(tenantAreaCd).slice(0, 4) !=
                //     patientInsurance.insuranceRegion.slice(0, 4)
                // ) {
                //   notification.info({
                //     message:
                //       '异地患者暂时不支持预收挂号费用，请在医生处方中手动开具挂号费',
                //   })
                //   setLoading(false)
                //   setRegisterLoading(false)
                // } else {
                  if(apiUserType === 'SYLD'){
                    submit({ ...values, ybJiuzhenid: "SYLD" }, undefined)
                  }else{
                    medicalSubmit(
                      { ...values, readType: String(cardType) },
                      'requestString'
                    )
                  }

                // }
              } else {
                notification.error({
                  message: '请先读卡',
                  duration: 1,
                })
              }
            }
          } else {
            // return
            if(apiUserType === 'SYLD'){
              submit({ ...values,readType: String(cardType), ybJiuzhenid: "SYLD" })
            }else{
              submit({ ...values, readType: String(cardType) })
            }

          }
        }}
        style={{
          flex: 1,
          marginTop: 10,
          marginBottom: 20,
          paddingBottom: 20,
          borderRadius: theme.br,
          backgroundColor: theme.pn,
          overflow: 'auto',
        }}
      >
        <Row wrap={false}>
          <Col flex={1}>
            <Form.Item
              label='挂号类别'
              name='registrationCategory'
              // style={{ marginTop: 25, marginLeft: 40 }}
              style={{ marginTop: 25 }}
              {...firstColumnLayout}
            >
              <Radio.Group
                value={value}
                onChange={(v) => {
                  setSameDayRegistrationFee('')
                  setPatientId('')
                  setTriageDetailId('')
                  setHasCard(false)
                  setDiabled(false)
                  setIsAdult(false)
                  setIdCardInputValid(false)
                  setAgeUnit('year')
                  form.setFieldsValue({
                    ageYear: '',
                    age: '',
                    ageMonth: '',
                    ageDay: '',
                    birthday: '',
                    name: '',
                    phone: '',
                    idCardNumber: '',
                    companyName: '',
                    address: '',
                    emergencyContactName: '',
                    emergencyContactPhone: '',
                    sex: 0,
                    source: 0,
                    patientSource: 0,
                    patientId: '',
                    area: [],
                  })
                  setTradeCntInfo({})
                  setAllLableNameList([])
                  setLableNameList([])
                  setKeywords('')
                  setKeyword('')
                  if (v.target.value == 0 && oweMoneyNum > 0) {
                    //欠费金额是否显示
                    setOweMoneyNumShow(true)
                  }
                  //2.根据偏好设置获取性别，如果没有就默认未知 1:男，2:女，0:未知
                  //3.根据偏好设置获取患者来源，如果没有就默认空

                  form.setFieldsValue({
                    sex: HZXB,
                  })
                  setDefaultPatientSource();

                  setValue(v.target.value)
                  getMedicalNum()

                  setUrlParam('');
                  setMdtrt_cert_type('');
                }}
                disabled={hasCard}
              >
                <Radio
                  value={RegistrationCategory.SelfPay}
                  key={RegistrationCategory.SelfPay}
                  onClick={() => {
                    setIsHisCode(false)
                    setInsuranceItem({})
                  }}
                >
                  自费
                </Radio>
                {insuranceArray.length !== 0 &&
                  insuranceArray.map((v: MedicelListValue) => (
                    <Radio
                      key={v.id}
                      value={v}
                      onClick={() => {
                        setOweMoneyNumShow(false)
                        setIsHisCode(true)
                        setInsuranceItem(v)
                        form.setFieldsValue({
                          readType: 1,
                        })
                      }}
                    >
                      {v.insuranceName}
                    </Radio>
                  ))}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col
            span={6}
            style={{
              paddingTop: 25,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'right',
              marginRight: 30,
            }}
          >
            <Form.Item label='病历号' name='patientId'>
              <Input disabled />
            </Form.Item>
            {/* <RefreshFilled
              style={{
                marginTop: -10,
                marginLeft: 10,
                cursor: 'pointer',
                fill: '#11a9cb',
              }}
              onClick={() => {
                getResiterMedicalNum()
              }}
            /> */}
          </Col>
        </Row>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: 30,
            position: 'relative',
          }}
        >
          <Label label={'患者基本信息'} />
          {patientInsurance?.ybType?.toString() ? (
            <p
              style={{
                position: 'absolute',
                top: 10,
                left: 150,
                fontSize: '14px',
              }}
            >
              <span style={{ color: 'rgb(7, 193, 96)', marginRight: '20px' }}>
                {getYBTypeName(patientInsurance?.ybType?.toString())}
                {patientInsurance?.insuranceRegionName
                  ? ' ( ' + patientInsurance?.insuranceRegionName + ' ) '
                  : ''}
              </span>
              {patientInsurance?.patientId?.toString() ? (
                <span
                  style={{
                    color: '#FAB714',
                  }}
                >
                  {patientInsurance?.patientId == -1
                    ? '本年首次'
                    : notice?.isFirstDiagnosisThisYear
                      ? '本年首次'
                      : '本年复诊'}
                </span>
              ) : (
                ''
              )}
            </p>
          ) : (
            ''
          )}
          {patientInsurance?.patientId?.toString() ? (
            <p
              style={{
                position: 'absolute',
                top: 10,
                left: 226,
              }}
            ></p>
          ) : (
            ''
          )}
          {/*  display: oweMoneyNum && oweMoneyNum == 0 ? 'inline-block' : 'none',  ref={oweMoneyNumRef} (oweMoneyShow?.openOwe == 1) &&  */}
          {oweMoneyShow?.openOwe == 1 && oweMoneyNumShow && (
            <>
              <span
                style={{
                  marginLeft: '15px',
                  color: '#ff661a',
                }}
              >
                {`(欠费金额：${Number(oweMoneyNum).toFixed(2)} 元)`}
              </span>
              {/* {!!owelabel.length &&
                owelabel.map((v: any) => (
                  <Tooltip key={v.id} title={v.name}>
                    <span
                      style={{
                        backgroundColor: v.backgroundColor,
                        color: v.fontColor,
                        width: 18,
                        height: 18,
                        marginLeft: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {v.headName}
                    </span>
                  </Tooltip>
                ))} */}
            </>
          )}
        </div>
        <Divider
          style={{ marginTop: 0, marginBottom: 20, borderColor: theme.c3 }}
        />
        <Row
          gutter={formGutter}
          style={{ marginLeft: 5, marginRight: 20 }}
          className={styles.formItem}
        >
          <Col span={16} order={1}>
            <Form.Item
              required
              label='患者姓名'
              {...firstColumnLayout}
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
              }}
            >
              <Row wrap={false} className={styles.patientNameContent}>
                <div style={{ flex: 1 }}>
                  <Form.Item
                    noStyle
                    name='name'
                    rules={[
                      { required: true, max: 40, message: '请输入患者姓名' },
                    ]}
                  >
                    {value == 0 ? (
                      <Dropdown
                        overlay={
                          source === 0 ? patientOverlay : taiagelistOverlay
                        }
                        visible={isPatientNameOverlayVisible}
                        disabled={hasCard || diabled}
                      // onVisibleChange={(v) => setIsPatientOverlayVisible(v)}
                      >
                        <Input
                          className={styles.patientNameInput}
                          disabled={!!patientId || !!TriageDetailId}
                          readOnly={hasCard || diabled}
                          allowClear
                          placeholder={
                            source === 0
                              ? '姓名/性别/手机号/就诊卡号'
                              : '姓名/性别/手机号'
                          }
                          prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
                          addonAfter={
                            allLableNameList?.length || isAdult ?
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  {lableNameList?.map((v: any) => {
                                    return (
                                      <Tooltip key={v.id} title={v.name}>
                                        <span
                                          key={v}
                                          style={{
                                            width: 24,
                                            height: 24,
                                            marginLeft: 3,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: v.backgroundColor,
                                            color: v.fontColor,
                                            marginRight: '6px',
                                            borderRadius: '50%',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          {v?.headName}
                                        </span>
                                      </Tooltip>
                                    )
                                  })}
                                </div>
                                {isAdult ? (
                                  <Tooltip key={'未成年'} title={'未成年'}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '2px' }}>
                                      <UnderageIcon
                                        style={{
                                          color: theme.tc3,
                                        }}
                                      />
                                    </div>
                                  </Tooltip>
                                ) : (
                                  ''
                                )}
                              </div> : undefined
                          }
                          value={keywords}
                          onFocus={() => {
                            if (source === 0) {
                              dispatch(getPatientList(keywords, 30))
                              setSource(0)
                            } else if (source === 1) {
                              dispatch(
                                getTriageHistorylist({
                                  name: keywords,
                                  size: 10,
                                })
                              )
                                .then(unwrapResult)
                                .then((v: any) => {
                                  setList(v?.records)
                                })
                              setSource(1)
                            }
                            setIsPatientNameOverlayVisible(true)
                            setIsPatientOverlayVisible(false)
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setIsPatientNameOverlayVisible(false)
                            }, 300)
                          }}
                          onClick={() => {
                            setIsPatientNameOverlayVisible(true)
                            setIsPatientOverlayVisible(false)
                          }}
                          onChange={(e) => {
                            setIsPatientNameOverlayVisible(true)
                            setIsPatientOverlayVisible(false)
                            setKeywords(e.target.value)
                            setKeyword('')
                            setNameFlag(true)
                          }}
                        />
                      </Dropdown>
                    ) : (
                      <Input
                        autoFocus
                        disabled={!!patientId || !!TriageDetailId}
                        readOnly={hasCard && !otherCountyCard}
                        onClick={() => readMessage()}
                        addonAfter={
                          allLableNameList?.length || isAdult ?
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {lableNameList?.map((v: any) => (
                                  <Tooltip key={v.id} title={v.name}>
                                    <span
                                      key={v}
                                      style={{
                                        width: 24,
                                        height: 24,
                                        marginLeft: 3,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: v.backgroundColor,
                                        color: v.fontColor,
                                        marginRight: '6px',
                                        borderRadius: '50%',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      {v?.headName}
                                    </span>
                                  </Tooltip>
                                ))}
                              </div>
                              {isAdult ? (
                                <Tooltip key={'未成年'} title={'未成年'}>
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '2px' }}>
                                    <UnderageIcon
                                      style={{
                                        color: theme.tc3,
                                        // position: 'relative',
                                        // top: '3px',
                                      }}
                                    />
                                  </div>
                                </Tooltip>
                              ) : (
                                ''
                              )}
                            </div> : undefined
                        }
                        onBlur={() => {
                          if (
                            (form.getFieldValue('name') &&
                              form.getFieldValue('idCardNumber')) ||
                            (form.getFieldValue('name') &&
                              form.getFieldValue('phone'))
                          ) {
                            getOweMoneyFn(
                              '',
                              form.getFieldValue('idCardNumber'),
                              form.getFieldValue('name'),
                              form.getFieldValue('phone')
                            )
                            isSee(
                              '',
                              form.getFieldValue('idCardNumber'),
                              form.getFieldValue('name'),
                              form.getFieldValue('phone')
                            )
                          }
                        }}
                      />
                    )}
                  </Form.Item></div>
                {!isHisCode &&
                  <div style={{ width: '100px' }}>
                    <Button
                      loading={readLoadingSfz}
                      style={{ marginLeft: '10px' }}
                      type='primary'
                      onClick={() => {
                        setReadLoadingSfz(true);
                        //开通医保刷脸的机构，使用刷脸机器的身份证读卡器
                        const item = insuranceArray?.filter(
                          (v: any) => v.insuranceCode != 'ZIFEI'
                        )?.[0]
                        if (item?.ybFaceRecognition == 1) {
                          readCardSfzHttp(
                            {
                              trade_args: [
                                item.countryHospitalNb,
                                '01301',
                                'cn.nhsa.cert.get',
                                userId,
                                userName,
                                '',
                                '',
                              ],
                            },
                            (data, err) => {
                              if (!err) {
                                form.setFieldsValue({
                                  // ybkh: res?.patientInsurance.CardNum,
                                  name: data.userName,
                                  idCardNumber: data.idNo,
                                  sex: data.gender == '男' ? 1 : data.gender == '女' ? 2 : 0,
                                  address: data.address,
                                })
                                setKeywords(data.userName);
                                getIdCardInfo(data.idNo)
                                setReadLoadingSfz(false);
                                isAdultFn(data.idNo, '')
                              }
                              setReadLoadingSfz(false);
                            }
                          )
                        } else {
                          IDCardRead((data, err) => {
                            if (!err) {
                              form.setFieldsValue({
                                // ybkh: res?.patientInsurance.CardNum,
                                name: data.name,
                                idCardNumber: data.idCardNo,
                                sex: data.sex == '男' ? 1 : data.sex == '女' ? 2 : 0,
                                address: data.address,
                              })
                              setKeywords(data.name);
                              getIdCardInfo(data.idCardNo)
                              setReadLoadingSfz(false);
                              isAdultFn(data.idCardNo, '')
                            } else {
                              setReadLoadingSfz(false);
                            }
                          });
                          return
                        }

                      }}
                    >
                      读身份证
                    </Button></div>}
                {isHisCode && (
                  <div style={{ width: insuranceItem?.ybFaceRecognition == 1 ? '386px' : '286px' }}>
                    <Button
                      style={{
                        marginLeft: '10px'
                      }}
                      // type='link'
                      type='primary'
                      ghost
                      disabled={
                        readLoadingDzpz || readLoadingStk || readLoadingSfz
                      }
                      ref={readCardRef}
                      onClick={() => {
                        revertPage()
                      }}
                    >
                      清空
                    </Button>
                    <Button
                      style={{
                        marginLeft: '10px'
                      }}
                      // type='link'
                      type='primary'
                      ref={readCardRef}
                      loading={readLoadingDzpz}
                      disabled={
                        readLoadingDzpz ||
                        readLoadingStk ||
                        readLoadingSfz ||
                        readLoadingRl
                      }
                      onClick={() => {
                        if (cardType === 1) {
                          notification.warn({
                            message: '请先点击清空',
                          })
                        } else {
                          setCardType(1)
                        }
                      }}
                    >
                      读电子凭证
                    </Button>
                    {tenantName?.indexOf('测试') >= 0 && (
                      <Button
                        style={{
                          marginLeft: '10px'
                        }}
                        // type='link'
                        type='primary'
                        ref={readCardRef}
                        disabled={
                          readLoadingDzpz ||
                          readLoadingStk ||
                          readLoadingSfz ||
                          readLoadingRl
                        }
                        loading={readLoadingSfz}
                        onClick={() => {
                          if (cardType === 2) {
                            notification.warn({
                              message: '请先点击清空',
                            })
                          } else {
                            setCardType(2)
                          }
                        }}
                      >
                        身份证号码
                      </Button>
                    )}
                    <Button
                      style={{
                        marginLeft: '10px'
                      }}
                      // type='link'
                      type='primary'
                      ref={readCardRef}
                      disabled={
                        readLoadingDzpz ||
                        readLoadingStk ||
                        readLoadingSfz ||
                        readLoadingRl
                      }
                      loading={readLoadingStk}
                      onClick={() => {
                        if (cardType === 3) {
                          notification.warn({
                            message: '请先点击清空',
                          })
                        } else {
                          setCardType(3)
                        }
                      }}
                    >
                      读医保卡
                    </Button>
                    {insuranceItem?.ybFaceRecognition == 1 && (
                      <Button
                        style={{
                          marginLeft: '10px'
                        }}
                        // type='link'
                        type='primary'
                        ref={readCardRef}
                        disabled={
                          readLoadingDzpz ||
                          readLoadingStk ||
                          readLoadingSfz ||
                          readLoadingRl
                        }
                        loading={readLoadingRl}
                        onClick={() => {
                          if (cardType === 2) {
                            notification.warn({
                              message: '请先点击清空',
                            })
                          } else {
                            setCardType(1)
                            setFaceAuth(true)
                          }
                        }}
                      >
                        医保刷脸
                      </Button>
                    )}
                  </div>
                )}
              </Row>
            </Form.Item>
          </Col>

          <Col span={8} order={3}>
            <Form.Item
              label='年龄'
              {...firstColumnLayout}
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
              }}
              required
            >
              <Row wrap={false} align='middle' style={{ height: '50px' }}>
                <Form.Item
                  name={ageUnit === 'month' ? 'ageMonth' : (source === 0 ? 'ageYear' : 'age')}
                  noStyle
                  dependencies={ageUnit === 'month' ? ['ageDay'] : ['ageMonth']}
                  rules={[
                    {
                      pattern: ageUnit === 'month' ? /^(1[01]|[0-9])$/ : /^(200|[01]?[0-9]{1,2})$/,
                      message: ageUnit === 'month' ? '请输入正确的月份' : '请输入正确的年龄',
                    },
                    ({ getFieldValue }) => ({
                      validator: (_, value) => {
                        const secondField = ageUnit === 'month' ? getFieldValue('ageDay') : getFieldValue('ageMonth')
                        if (!value && !secondField) {
                          return Promise.reject(new Error('请输入正确的年龄'))
                        }
                        return Promise.resolve()
                      },
                    }),
                  ]}
                >
                  <Input
                    readOnly={hasCard && !otherCountyCard}
                    disabled={idCardInputValid}
                    onClick={() => readMessage()}
                    onChange={updateBirthday}
                    style={{ maxWidth: '3rem' }}
                  />
                </Form.Item>
                <Dropdown
                  disabled={idCardInputValid}
                  trigger={['click']}
                  overlay={
                    <Menu
                      selectedKeys={[ageUnit]}
                      onClick={({ key }) => {
                        if (key !== ageUnit) {
                          const newUnit = key as 'year' | 'month'

                          const rawFirst = form.getFieldValue(ageUnit === 'month' ? 'ageMonth' : (source === 0 ? 'ageYear' : 'age'))
                          const rawSecond = form.getFieldValue(ageUnit === 'month' ? 'ageDay' : 'ageMonth')

                          if (newUnit === 'month') {
                            // 岁→月：数值搬家，10岁3月 → 10月3天
                            form.setFieldsValue({
                              ageMonth: rawFirst,
                              ageDay: rawSecond,
                            })
                            setAgeUnit('month')
                            // 按搬家后的数值重新计算 birthday
                            const months = parseInt(rawFirst) || 0
                            const days = parseInt(rawSecond) || 0
                            if (months || days) {
                              const birthday = moment().subtract(months, 'months').subtract(days, 'days').format('YYYY/MM/DD')
                              form.setFieldsValue({ birthday })
                              isAdultFn('', birthday)
                            }
                            setTimeout(() => {
                              if (rawFirst || rawSecond) {
                                form.validateFields(['ageMonth', 'ageDay'])
                              }
                            })
                          } else {
                            // 月→岁：数值搬家，10月3天 → 10岁3月
                            form.setFieldsValue({
                              ageYear: rawFirst,
                              age: rawFirst,
                              ageMonth: rawSecond,
                            })
                            setAgeUnit('year')
                            // 按搬家后的数值重新计算 birthday
                            const years = parseInt(rawFirst) || 0
                            const months = parseInt(rawSecond) || 0
                            if (years || months) {
                              const birthday = moment().subtract(years, 'years').subtract(months, 'months').format('YYYY/MM/DD')
                              form.setFieldsValue({ birthday })
                              isAdultFn('', birthday)
                            }
                            setTimeout(() => {
                              if (rawFirst || rawSecond) {
                                form.validateFields(['ageYear', 'ageMonth'])
                              }
                            })
                          }
                        }
                      }}
                      style={{ minWidth: 50 }}
                    >
                      <Menu.Item key="year">岁</Menu.Item>
                      <Menu.Item key="month">月</Menu.Item>
                    </Menu>
                  }
                >
                  <div
                    style={{
                      color: theme.tc2,
                      fontSize: '1rem',
                      margin: '0 6px',
                      cursor: 'pointer',
                      userSelect: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                    }}
                  >
                    {ageUnit === 'year' ? '岁' : '月'}
                    <CaretDownFilled style={{ fontSize: '0.7rem', marginLeft: 2 }} />
                  </div>
                </Dropdown>
                <Form.Item
                  name={ageUnit === 'month' ? 'ageDay' : 'ageMonth'}
                  noStyle
                  dependencies={ageUnit === 'month' ? ['ageMonth'] : ['ageYear']}
                  rules={[
                    {
                      pattern: ageUnit === 'month' ? /^(30|[012]?[0-9])$/ : /^(1[01]|[0-9])$/,
                      message: ageUnit === 'month' ? '请输入正确的天数' : '请输入正确的月份',
                    },
                  ]}
                >
                  <Input
                    readOnly={hasCard && !otherCountyCard}
                    disabled={idCardInputValid}
                    onClick={() => readMessage()}
                    onChange={updateBirthday}
                    style={{ maxWidth: '3rem' }}
                  />
                </Form.Item>
                <div
                  style={{
                    color: theme.tc2,
                    fontSize: '1rem',
                    margin: '0 6px',
                  }}
                >
                  {ageUnit === 'year' ? '月' : '天'}
                </div>
                <Form.Item
                  name='birthday'
                  noStyle
                  style={{ flex: 1 }}
                  rules={[
                    { max: 10, message: '最多10个字' },
                    {
                      pattern: /^(?:1\d{3}|2\d{3})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})\/(?:0[1-9]|1[0-2])\/(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])$/,
                      message: '格式参考:19950816',
                    },
                  ]}
                >
                  <Input
                    placeholder=' 格式：年  月  日，例：19980808'
                    onChange={() => updateYearsAndMonths()}
                    readOnly={hasCard && !otherCountyCard}
                    disabled={idCardInputValid}
                    onClick={() => readMessage()}
                  />
                </Form.Item>
              </Row>
            </Form.Item>
          </Col>
          <Col span={8} order={2}>
            <Form.Item
              {...required}
              label='性别'
              name='sex'
              className={styles.normal}
              {...thirdColumnLayout}
            >
              <Radio.Group
                disabled={hasCard && !otherCountyCard || idCardInputValid}
                onChange={(e) => {
                  setSexTag(true)
                }}
              >
                {[Gender.Male, Gender.Female, Gender.Unknown].map((g) => (
                  <Radio key={g} value={g}>
                    {getGenderName(g)}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
          {/* </Row>
        <Row gutter={formGutter} style={{ marginLeft: 5, marginRight: 20 }}> */}
          <Col span={8} order={6}>
            <Form.Item
              label='联系方式'
              name='phone'
              {...firstColumnLayout}
              rules={[
                phoneInfo?.phoneDisabled ? {} : { ...phonePatterns },
                {
                  required: fieldSettingList?.find((item: any) => item.key === 'phone')?.isRequired,
                  message: '请输入联系方式',
                }]}
            >
              <Input
                maxLength={13}
                disabled={phoneInfo?.phoneDisabled}
                onBlur={() => {
                  if (
                    (form.getFieldValue('name') &&
                      form.getFieldValue('idCardNumber')) ||
                    (form.getFieldValue('name') && form.getFieldValue('phone'))
                  ) {
                    getOweMoneyFn(
                      '',
                      form.getFieldValue('idCardNumber'),
                      form.getFieldValue('name'),
                      form.getFieldValue('phone')
                    )
                    isSee(
                      '',
                      form.getFieldValue('idCardNumber'),
                      form.getFieldValue('name'),
                      form.getFieldValue('phone')
                    )
                  }
                }}
                suffix={
                  phoneInfo?.phoneDisabled ? (
                    <CloseCircleFilled
                      onClick={() => {
                        form.setFieldsValue({ phone: '' })
                        setPhoneInfo({
                          ...phoneInfo,
                          phone: '',
                          phoneDisabled: false,
                        })
                      }}
                      style={{ color: '#999', cursor: 'pointer' }}
                    />
                  ) : null
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} order={4}>
            <Form.Item
              label='身份证号'
              name='idCardNumber'
              {...secondColumnLayout}
              rules={[
                ...idCardRules,
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'idCardNumber')?.isRequired,
                  message: "请输入身份证号"
                },
              ]}
            >
              <Input
                readOnly={hasCard && !otherCountyCard}
                onClick={() => readMessage()}
                onChange={(e: any) => {
                  // setIdCard(e.target.value)
                  getIdCardInfo(e.target.value)
                }}
                onBlur={() => {
                  if (
                    (form.getFieldValue('name') &&
                      form.getFieldValue('idCardNumber')) ||
                    (form.getFieldValue('name') && form.getFieldValue('phone'))
                  ) {
                    getOweMoneyFn(
                      '',
                      form.getFieldValue('idCardNumber'),
                      form.getFieldValue('name'),
                      phoneInfo?.phone || ''
                    )
                    isSee(
                      '',
                      form.getFieldValue('idCardNumber'),
                      form.getFieldValue('name'),
                      phoneInfo?.phone || ''
                    )
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8} order={5}>
            <Form.Item
              label='工作单位'
              name='companyName'
              {...thirdColumnLayout}
              rules={[
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'companyName')?.isRequired,
                  message: "请输入工作单位"
                },
                {
                  max: 120,
                  message: '最长120位!',
                },
              ]}
            >
              <Input readOnly={hasCard} onClick={() => readMessage()} />
            </Form.Item>
          </Col>
          {/* </Row>
        <Row gutter={formGutter} style={{ marginLeft: 5, marginRight: 20 }}> */}
          <Col span={8} order={7}>
            <Form.Item
              label='家庭地区'
              name='area'
              {...secondColumnLayout}
              rules={[
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'area')?.isRequired,
                  message: "请选择家庭地区"
                },
              ]}
            >
              <Cascaded
                allowClear={false}
                // loadData={loadData}
                options={allList}
                placeholder='请选择'
              />
            </Form.Item>
          </Col>

          <Col span={8} order={8}>
            <Form.Item
              label='详细地址'
              name='address'
              {...thirdColumnLayout}
              rules={[
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'address')?.isRequired,
                  message: "请输入详细地址"
                },
                {
                  max: 250,
                  message: '最长250位!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={formGutter}
          style={{ marginLeft: 5, marginRight: 20 }}
          className={styles.formItem}
        >
          <Col span={8}>
            <Form.Item
              label='紧急联系人'
              name='emergencyContactName'
              {...firstColumnLayout}
              rules={[
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'emergencyContactName')?.isRequired,
                  message: "请输入紧急联系人"
                },
                {
                  max: 40,
                  message: '最长40位!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='紧急联系方式'
              name='emergencyContactPhone'
              className={styles.normal}
              {...secondColumnLayout}
              rules={[
                phoneInfo?.emergencyContactPhoneDisabled ? {} : { ...phonePatterns },
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'emergencyContactPhone')?.isRequired,
                  message: "请输入紧急联系方式"
                }]}
            >
              <Input
                disabled={phoneInfo?.emergencyContactPhoneDisabled}
                suffix={
                  phoneInfo?.emergencyContactPhoneDisabled ? (
                    <CloseCircleFilled
                      onClick={() => {
                        form.setFieldsValue({ emergencyContactPhone: '' })
                        setPhoneInfo({
                          ...phoneInfo,
                          emergencyContactPhone: '',
                          emergencyContactPhoneDisabled: false,
                        })
                      }}
                      style={{ color: '#999', cursor: 'pointer' }}
                    />
                  ) : null
                } />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='患者来源'
              name='patientSource'
              {...thirdColumnLayout}
              rules={[
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'patientSource')?.isRequired,
                  message: "请选择患者来源"
                },
              ]}
            >
              <Select
                placeholder='患者来源'
                allowClear
              // suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
              >
                {classificationList?.sourceList.map((v: any) => {
                  return (
                    <Select.Option key={v.name} value={v.name}>
                      {v.name}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
            <div style={{ position: 'absolute', top: '5px', right: '-10px', zIndex: 999 }}>
              <SettingOutlined
                style={{ color: '#999999', fontSize: '16px' }}
                onClick={() => {
                  setSettingOptionsVisible(true)
                  setSettingType('1')
                }}
              />
            </div>
          </Col>
          {isHisCode && (
            <>
              <Col span={8}>
                <Form.Item
                  name='cbxzmc'
                  label='险种类别'
                  {...firstColumnLayout}
                >
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name='memberTypemc'
                  label='人员类别'
                  {...secondColumnLayout}
                >
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name='treatmentStatusmc'
                  label='参保状态'
                  style={{ "display": "none" }}
                  {...thirdColumnLayout}
                >
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
                <Form.Item
                  name='extraPeopleTypemc'
                  label='身份类别'
                  {...thirdColumnLayout}
                >
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name='zhye' label='账户余额' {...firstColumnLayout}>
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name='dnzhye'
                  label='当年余额'
                  {...secondColumnLayout}
                >
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name='lnzhye'
                  label='历年余额'
                  {...thirdColumnLayout}
                >
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name='ybkh' label='医保卡号' {...firstColumnLayout}>
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name='ybPersonalNo'
                  label='个人编号'
                  {...secondColumnLayout}
                >
                  <Input readOnly onClick={() => readMessage()} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ display: 'flex', alignItems: 'center' }}>
                <Form.Item>
                  <Button
                    disabled={searchPsnSumDisabled}
                    type='link'
                    onClick={() => {
                      if (patientInsurance?.ybPersonalNo) {
                        setSearchPsnSumDisabled(true)
                        // if (sumList && JSON.stringify(sumList) !== '{}') {
                        //   setSumVisible(true)
                        // } else {
                        searchPsnSum(
                          true,
                          'requestString',
                          patientInsurance.ybPersonalNo,
                          patientInsurance?.insuranceRegion
                        )
                        // }
                      } else {
                        notification.warn({
                          message: '请先读卡',
                          duration: 1.5,
                        })
                      }
                    }}
                  >
                    查询医保账户累计
                  </Button>
                  {patientInsurance?.insuranceCode &&
                    patientInsurance?.insuranceCode == 'ZHEJIANG' &&
                    (
                      <Button
                        disabled={searchPsnSumDisabled}
                        type='link'
                        style={{paddingLeft:0}}
                        onClick={() => {
                          if (patientInsurance?.ybPersonalNo) {
                            if (form.getFieldValue('registrationDoctorId')) {
                              setIsMedicationAdministrationRecordVisible(true)
                            } else {
                              notification.warn({
                                message: '请选择医生',
                                duration: 1.5,
                              })
                            }
                          } else {
                            notification.warn({
                              message: '请先读卡',
                              duration: 1.5,
                            })
                          }
                        }}
                      >
                        近90天就诊记录
                      </Button>
                    )}
                  {tongchouLJ != '' && (
                    <Button type='link' style={{paddingLeft:0}}>
                      本年统筹累计：{tongchouLJ}
                    </Button>
                  )}
                </Form.Item>



              </Col>
            </>
          )}
        </Row>
        <Row
          gutter={formGutter}
          style={{ marginLeft: 5, marginRight: 20 }}
          className={styles.formItem}
        >
          <Col span={8}>
            <Form.Item
              label='民族'
              name='nation'
              {...firstColumnLayout}
              rules={[
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'nation')?.isRequired,
                  message: "请选择民族"
                },
              ]}
            >
              <Select
                allowClear
                placeholder='请选择民族'
              >
                {NATION_LIST.map((nation) => (
                  <Select.Option key={nation} value={nation}>
                    {nation}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='籍贯'
              name='nativePlace'
              {...secondColumnLayout}
              rules={[
                {
                  required: fieldSettingList?.find((item: any) => item.key == 'nativePlace')?.isRequired,
                  message: "请输入籍贯"
                },
                {
                  max: 40,
                  message: '最长40位!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          {patientInsurance?.insuranceCode &&
            patientInsurance?.insuranceCode == 'ZHEJIANG' &&
              <Col span={8} style={{display: 'flex'}}>
                  <Button
                      type='link'
                      style={{
                        color: '#027AFF',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setIsYBJRJSModalVisible(true)
                      }}
                  >
                    {"今日结算" + (tradeCntInfo?.todayCnt || 0) + "次，本月结算" + (tradeCntInfo?.monthCnt || 0) + "次"}
                  </Button>
              </Col>
          }
        </Row>
        <Label label='就诊信息' style={{ marginLeft: 30 }} />
        <Divider
          style={{ marginTop: 0, marginBottom: 1, borderColor: theme.c3 }}
        />
        <Row>
          <Col span={8}></Col>
          <Col span={16} style={{ height: '23px' }}>
            <Form.Item label='&nbsp;' {...tipsColumnLayout}>
              <p style={{ color: '#ef7202', marginLeft: '5px' }}>
                {lastTreatmentTimeInfo}
              </p>
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={formGutter}
          style={{ marginLeft: 5, marginRight: 20 }}
          className={styles.formItem}
        >
          <Col span={8}>
            <Form.Item
              label='医生科室'
              name='registrationDepartmentId'
              {...firstColumnLayout}
              {...required}
            >
              <Select
                placeholder='请选择'
                // suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                onChange={(id: string) => {
                  localStorage.setItem('registrationDepartmentId', id)
                  localStorage.removeItem('registrationDoctorId')
                  form.setFieldsValue({
                    registrationDoctorId: undefined,
                  })
                  setDoctors([])
                  getDoctorListInDepartment(id)
                  setTimeout(() => {
                    getLastTreatmentTimeByPatientIdAndDoctorId(form.getFieldValue("registrationDoctorId"), patientId);
                  }, 200)
                }}
              >
                <Select.Option key={'0'} value={'0'}>
                  未指定科室
                </Select.Option>
                {departments?.map((d) => (
                  <Select.Option key={d.id?.toString()} value={d.id?.toString()}>
                    {d.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8} className={styles.selectDisplay}>
            <Form.Item
              label='医生'
              name='registrationDoctorId'
              {...required}
              {...secondColumnLayout}
            >
              <Select
                placeholder='请选择'
                showSearch
                // suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                onChange={(id: string) => {
                  setWatchedDoctorId(id)
                  getLastTreatmentTimeByPatientIdAndDoctorId(id, patientId)
                  localStorage.setItem('registrationDoctorId', id)
                }}
                filterOption={(input, option) => {
                  return option?.className
                    ? ((option?.className as unknown) as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                    : false
                }}
              >
                <Select.Option key={'0'} value={'0'}>
                  未指定医生
                </Select.Option>
                {doctors?.map((d: any) => (
                  <Select.Option className={d.mnemonicCode} key={d.id?.toString()} value={d.id?.toString()} >
                    <span>{d.name}</span>
                    {d?.lastRegTime ? <span className={styles.lastRegTime}>（</span> : ''}
                    <span style={{ color: '#ff8345' }} className={styles.lastRegTime}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                    {d?.lastRegTime ? <span className={styles.lastRegTime}>）</span> : ''}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {tenantCategory == 16 ?
            <Col span={8} className={styles.selectDisplay}>
              <Form.Item
                label='助理'
                name='treatmentAssistantDoctorId'
                {...thirdColumnLayout}
              >
                <Select>
                  {treatmentAssistantDoctorList?.map((d) => (
                    <Select.Option key={d.id} value={d.id} >
                      <span>{d.realname}</span>
                      {d?.lastRegTime ? <span>（</span> : ''}
                      <span style={{ color: '#ff8345' }}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                      {d?.lastRegTime ? <span>）</span> : ''}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> :
            <Col span={8}>
              <Form.Item
                className={styles.normal}
                name='skipPrinting'
                valuePropName='checked'
              >
                <Checkbox
                  onChange={(e) => {
                    dispatch(
                      setSettings({
                        [Settings.Registration.SkipPrinting]: e.target.checked,
                      })
                    )
                    localStorage.setItem(
                      'registrationPrint',
                      JSON.stringify(e.target.checked)
                    )
                  }}
                >
                  跳过打印挂号小票
                </Checkbox>
              </Form.Item>
            </Col>
          }
        </Row>
        <Row gutter={formGutter} style={{ marginLeft: 5, marginRight: 20 }}>
          <Col span={8}>
            <Form.Item
              label='接诊类型'
              name='receiveTag'
              initialValue={VisitType.First}
              {...required}
              {...firstColumnLayout}
            >
              <Radio.Group onChange={(e: any) => setWatchedReceiveTag(e.target.value)}>
                {[VisitType.First, VisitType.Subsequence].map((t) => (
                  <Radio key={t} value={t}>
                    {getVisitTypeName(t)}
                  </Radio>
                ))}
              </Radio.Group>
              {/* <Select
                // suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
              >
                {[VisitType.First, VisitType.Subsequence].map((t) => (
                  <Select.Option key={t} value={t}>
                    {getVisitTypeName(t)}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={8} className={styles.selectYSGHF}>
            <Form.Item noStyle dependencies={['receiveInAdvance']}>
              {({ getFieldValue }) =>
                getFieldValue('receiveInAdvance') ? (
                  <Form.Item
                    label='门诊挂号费'
                    name='registrationFeeId'
                    required
                    {...secondColumnLayout}
                    rules={[{ required: true, message: '请选择门诊挂号费' }]}
                  >
                    <Select
                      style={{minHeight:'32px'}}
                      mode="multiple"
                      allowClear
                      placeholder='请选择门诊挂号费'
                      placement='topLeft'
                      // suffixIcon={
                      //   <CaretDownFilled style={{ color: theme.tc3 }} />
                      // }
                      onChange={(v, s: any) => {
                        // 多选模式下，s可能是数组，需要处理
                        const isInsurance = Array.isArray(s) 
                          ? s.some(item => item?.className)
                          : !!s?.className
                        setIsInsurance(isInsurance)
                      }}
                    >
                      {fees.map((f) => (
                        <Select.Option
                          className={f.hilistCode}
                          key={f.id}
                          value={f.id}
                        >{`${f.name}/${f.unitPrice?.toFixed(2) || 'N/A'}元${f.hilistCode ? '' : '（未匹配）'
                          }`}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : undefined
              }
            </Form.Item>
          </Col>
          <Col span={tenantCategory == 16 ? 3 : 8}>
            <Form.Item
              style={{ position: 'relative' }}
              className={styles.normal}
              name='receiveInAdvance'
              valuePropName='checked'
            >
              <Checkbox
                onChange={(e) => {
                  setWatchedAdvance(e.target.checked)
                  if (!e.target.checked) {
                    form.setFieldsValue({ registrationFeeId: undefined })
                  }

                  localStorage.setItem(
                    'registrationCharge',
                    JSON.stringify(e.target.checked)
                  )
                }}
              >
                预收挂号费用
              </Checkbox>
            </Form.Item>
            {tenantCategory == 16 ? '' :
              <span
                style={{
                  color: 'rgb(250, 183, 20)',
                  fontSize: '16px',
                  position: 'absolute',
                  top: 4,
                  left: 150,
                }}
              >
                {sameDayRegistrationFee ? '今日已收取挂号费' : ''}
              </span>
            }
          </Col>
          {tenantCategory == 16 ?
            <Col span={5}>
              <Form.Item
                className={styles.normal}
                name='skipPrinting'
                valuePropName='checked'
              >
                <Checkbox
                  onChange={(e) => {
                    dispatch(
                      setSettings({
                        [Settings.Registration.SkipPrinting]: e.target.checked,
                      })
                    )
                    localStorage.setItem(
                      'registrationPrint',
                      JSON.stringify(e.target.checked)
                    )
                  }}
                >
                  跳过打印挂号小票
                </Checkbox>
              </Form.Item>
            </Col> :
            <></>
          }
        </Row>
        {tenantCategory != 16 && <Row gutter={formGutter} style={{ marginLeft: 5, marginRight: 20 }}>
          <Col span={8}>
            <Form.Item
              label='助理'
              name='treatmentAssistantDoctorId'
              {...firstColumnLayout}
            >
              <Select>
                {treatmentAssistantDoctorList?.map((d) => (
                  <Select.Option key={d.id} value={d.id} >
                    <span>{d.realname}</span>
                    {d?.lastRegTime ? <span>（</span> : ''}
                    <span style={{ color: '#ff8345' }}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                    {d?.lastRegTime ? <span>）</span> : ''}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              name='remark'
              label='备注'
              {...tipsColumnLayout}
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
              }}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>}
        {tenantCategory == 16 ? <Row
          gutter={formGutter}
          style={{ margin: '8px 20px 0 5px'}}
          className={styles.formItem}
        >
          <Col span={16}>
            <Form.Item
              name='remark'
              label='备注'
              {...firstColumnLayout}
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
              }}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <span
              style={{
                color: 'rgb(250, 183, 20)',
                fontSize: '16px',
                position: 'absolute',
                top: 4,
                left: 12,
              }}
            >
              {sameDayRegistrationFee ? '今日已收取挂号费' : ''}
            </span>
          </Col>
        </Row> : ''}
        <Row justify='center' style={{ marginTop: 15 }}>
          <Space size='large'>
            <Button
              onClick={() => {
                cancelForm()
              }}
              style={{
                lineHeight: '2.25rem',
                height: '2.25rem',
                padding: '0 24px',
              }}
            >
              取消
            </Button>
            <Button
              type='primary'
              loading={loading}
              style={{
                lineHeight: '2.25rem',
                height: '2.25rem',
                padding: '0 24px',
              }}
              onClick={() => {
                setTimeout(() => {
                  form.validateFields().then(() => {
                    form.submit()
                    dispatch(clearConfirmation())
                    enterLoading()
                  })
                }, 300)
              }}
            >
              挂号
            </Button>
            {value != 0 && (
              <Button
                type='ghost'
                htmlType='submit'
                loading={loading}
                style={{
                  lineHeight: '2.25rem',
                  height: '2.25rem',
                  padding: '0 24px',
                  marginLeft: '30px',
                }}
                onClick={() => {
                  setYBZFRegister(true)
                }}
              >
                自费挂号
              </Button>
            )}
          </Space>
        </Row>
      </Form>
      {isOpen && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000
        }}>
          <Draggable handle=".handle">
            <div className="modal" style={{
              width: '600px',
              height: '552px',
              background: 'white',
              border: '1px solid #ccc',
              borderRadius: '8px',
              boxShadow: 'rgb(133 133 133 / 26%) 0px 0px 11px 2px',
              overflow: "hidden",
            }}>
              {/* 拖拽手柄 */}
              <div className="handle" style={{
                padding: '10px',
                background: 'linear-gradient(270deg, rgb(235, 134, 152) 0%, rgb(19, 102, 236) 100%)',
                borderBottom: '1px solid #eee',
                cursor: 'move',
                borderRadius: '3px 3px 0 0',
                color: "white"
              }}>
                挂号收费
                <button
                  onClick={() => setIsOpen(false)}
                  style={{ float: 'right', background: 'none', border: 'none', cursor: "pointer", color: '#fff', fontSize: 16 }}
                >
                  ✕
                </button>
              </div>

              <iframe
                src={url}
                style={{
                  width: '100%',
                  height: 'calc(100% - 44px)', // 减去标题栏高度，避免内容溢出
                  border: 'none',
                  borderBottomLeftRadius: '8px',
                  borderBottomRightRadius: '8px',
                  overflow: "hidden"
                }}
              />
            </div>
          </Draggable>
        </div>
      )}

      <Modal
        title='预收挂号费'
        width={950}
        cancelText='取消'
        okText='确认'
        confirmLoading={registerLoading}
        visible={isModalVisible}
        maskClosable={
          form.getFieldValue('registrationCategory')?.insuranceCode
            ? false
            : true
        }
        onCancel={() => {
          if (
            form.getFieldValue('registrationCategory')?.insuranceCode &&
            confirmation?.prePay
          ) {
            setIsCancelRegisterModalVisible(true)
          } else {
            setIsModalVisible(false)
            cancelForm()
            revertPage()
          }
        }}
        onOk={() => {
          setRegisterLoading(true)
          ref.current?.submit()
        }}
        bodyStyle={{ padding: 0 }}
      >
        <PaymentConfirm
          chrgBchno={2}
          ref={ref}
          membersStatus={0}
          confirmation={confirmation}
          YUSHOUGUAHAOFEI={true}
          YUSHOUtreatment={registerData}
          closePayLoading={() => setRegisterLoading(false)}
          onPay={(params) => {
            if (params.success) {
              notification.success({
                message:
                  params.success == '1'
                    ? '挂号费支付成功'
                    : '可以到待收费页面中继续收挂号费',
                duration: 1.5,
              })
              const data = {
                treatmentId: params?.paymentData?.treatmentId,
                patientId: params?.paymentData?.patientId,
                registrationId: registerData?.registrationId || 0,
                recipeId: params?.paymentData?.recipeId,
                paymentId: params?.paymentData?.id,
                payMethod: params?.paymentData?.payMethod,
                payment: params?.paymentData,
                patientName: params?.paymentData?.patientName,
                systemPayMethod: params?.paymentData?.systemPayMethod,
              }
              setRegisterData(data)
              setIsModalVisible(false)
              if (
                params?.paymentData?.payMethod?.split(',')?.find((v: any) => {
                  return v == 2
                })
              ) {
                setJuheIptShow(true)
                setPayCode('')
                setCancelPayBtn(false)
              } else {
                form.validateFields().then((values) => {
                  if (!values.skipPrinting) {
                    setSkipPrintingFlag(true)
                  } else {
                    if (query.has('redirect') && (values.skipPrinting && data?.registrationId && data?.registrationId > 0)) {
                      dispatch(
                        traceRoute({
                          name: '医生门诊',
                          path: '/treatment',
                          query: `registrationId=${data?.registrationId}`,
                        })
                      )
                    }
                    revertPage()
                  }
                })

              }
            } else {
              form.validateFields().then((values) => {
                setIsModalVisible(false)
                submit({ ...values, readType: String(cardType) }, params)
              })
            }
          }}
        />
      </Modal>
      <Modal
        className={styles.ModalContent}
        cancelText='返回'
        okButtonProps={{
          style: { display: 'none' },
        }}
        visible={sumVisible}
        title={`${patientInsurance?.name} ${sumList?.insutype} 账户年度累计`}
        onCancel={() => setSumVisible(false)}
      >
        <div style={{ marginTop: '-10px' }}>
          <span style={{ fontWeight: 'bold' }}>
            当年账户余额：{patientInsurance?.dnzhye}
          </span>
          <span style={{ fontWeight: 'bold', marginLeft: '10px' }}>
            历年账户余额：{patientInsurance?.lnzhye}
          </span>
        </div>
        <div>
          <span style={{ fontWeight: 'bold' }}>
            工作单位：{patientInsurance?.brdw}
          </span>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>
            人员类型：{patientInsurance?.memberTypemc}
          </span>
        </div>
        <Table
          scroll={{ y: 300 }}
          dataSource={sumList?.currYearInsCum}
          columns={[
            {
              title: '累计类型名称',
              align: 'left',
              width: '82%',
              render: (_, r) => {
                return r.name
              },
            },
            {
              title: '累计数',
              align: 'center',
              render: (_, r) => {
                return r.cum
              },
            },
          ]}
          pagination={false}
        />
      </Modal>
      <Modal
        width={800}
        okText='确定'
        cancelText='返回'
        visible={xianzhongVisible}
        title={`该患者存在多个参保险种`}
        onCancel={() => {
          setXianzhongVisible(false)
          revertPage()
        }}
        onOk={() => {
          if (!selectXianzhong || !selectXianzhong.insutype) {
            notification.error({
              message: '请选择一个险种。',
              duration: 1,
            })
          } else {
            setXianzhongVisible(false)
          }
        }}
      >
        {selectXianzhong && selectXianzhong.insutype ? (
          <span style={{ fontSize: '16px' }}>
            当前选择的是{' '}
            <span style={{ fontSize: '16px', color: '#027AFF' }}>
              [{getInsuName(selectXianzhong?.insutype)}]
            </span>
          </span>
        ) : (
          <span style={{ fontSize: '16px' }}>请选择一个参保险种</span>
        )}
        <Table
          className={styles.marginTop10}
          dataSource={xianzhongList}
          onRow={(d) => ({
            onClick: (e) => {
              e.stopPropagation()
              setSelectXianzhong(d)
            },
          })}
          rowClassName={(_, index) => {
            return selectXianzhong && _.insutype === selectXianzhong.insutype
              ? styles.rowBgColor
              : ''
          }}
          columns={[
            {
              title: '险种名称',
              align: 'left',
              render: (_, r) => {
                let check = ''
                if (r?.insutype == selectXianzhong?.insutype) {
                  check = '> '
                }
                return check + getInsuName(r?.insutype)
              },
            },
            {
              title: '人员类别',
              align: 'center',
              render: (_, r) => {
                return getRylb(r.psn_type)
              },
            },
            {
              title: '开始参保时间',
              align: 'center',
              render: (_, r) => {
                return r.psn_insu_date ? r.psn_insu_date : '-'
              },
            },
            {
              title: '暂停参保时间',
              align: 'center',
              render: (_, r) => {
                return r.paus_insu_date ? r.paus_insu_date : '-'
              },
            },
            {
              title: '余额',
              align: 'center',
              render: (_, r) => {
                return r.balc ? r.balc : '0'
              },
            },
            {
              title: '参保状态',
              align: 'center',
              render: (_, r) => {
                // 0	未参保	1	正常参保
                // 2	暂停参保	4	终止参保
                if (r.psn_insu_stas === '0') {
                  return '未参保'
                } else if (r.psn_insu_stas === '1') {
                  return '正常参保'
                } else if (r.psn_insu_stas === '2') {
                  return '暂停参保'
                } else if (r.psn_insu_stas === '4') {
                  return '终止参保'
                } else {
                  return '未知：' + r.psn_insu_stas
                }
              },
            },
          ]}
          pagination={false}
        />
      </Modal>
      <JuheIptShowModal
        ysghfFlag={true}
        paymentId={String(registerData?.paymentId)}
        juheText={JuheText}
        JHZFMoney={
          registerData?.payment?.systemPayMethod?.find(
            (v: any) => v?.payMethod == 2
          )?.payAmount || 0
        }
        JuheIptDisabled={JuheIptDisabled}
        cancelPayBtn={cancelPayBtn}
        visible={JuheIptShow}
        loading={loading}
        payCode={payCode}
        JHZFInputChange={(value: any) => {
          setPayCode(value)
          if (value.length == 18) {
            // 设置标志，表示已经调用过接口
            // 输入款是否满18位
            if (confirmation) {
              if (confirmation.errorMaterials.length > 0) {
                // 是否有库存不足
                setIsModalVisible(true)
                setLoading(false)
              } else {
                setJuheIptDisabled(true)
                dispatch(
                  JuhePayFn({
                    payCode: value,
                    payPrice:
                      registerData?.payment?.systemPayMethod?.find(
                        (v: any) => v?.payMethod == 2
                      )?.payAmount || 0,
                    treatmentId: registerData?.treatmentId as any,
                    patientName: registerData?.payment?.patientName,
                    type: 0,
                    recipeIdList: registerData?.payment?.recipeIdList,
                  })
                )
                  .then(unwrapResult)
                  .then((res) => {
                    setjuhePayId(res.data)
                    clearInterval(timer)
                    timer = null
                    setTimerFlag(true)
                    if (insuranceItem?.insuranceCode) {
                      if (!skipPrinting) {
                        setSkipPrintingFlag(true)
                      } else {
                        setSkipPrintingFlag(false)
                      }
                    }
                  })
                  .catch(() => {
                    setJuheIptDisabled(false)
                    setTimerFlag(false) //关闭定时器
                    clearInterval(timer)
                    setPayCode('')
                  })
              }
            }
          }
        }}
        onCancel={() => {
          form.validateFields().then((values) => {
            if (!values.skipPrinting) {
              setSkipPrintingFlag(true)
            } else {
              if (query.has('redirect') && (values.skipPrinting && registerData?.registrationId && registerData?.registrationId > 0)) {
                dispatch(
                  traceRoute({
                    name: '医生门诊',
                    path: '/treatment',
                    query: `registrationId=${registerData?.registrationId}`,
                  })
                )
              }
              revertPage()
            }
          })
          setJuheIptShow(false)
          setLoading(false)
          setRegisterLoading(false)
          setJuheText('请扫描（微信/支付宝）付款码')
          setCancelPayBtn(false)
          timer && clearInterval(timer)
          dispatch(
            cancelPayMoneyAsync({
              treatmentId: registerData?.treatmentId,
              recipeIdList: registerData?.payment?.recipeIdList,
            })
          )
            .then(unwrapResult)
            .then((v) => {
              return
            })
        }}
        cancelPayMoney={() => {
          setLoading(false)
          dispatch(
            JuhePayCancle({
              payId: juhePayId,
            })
          )
            .then(unwrapResult)
            .then((res) => {
              notification.success({
                message: '撤销成功',
              })
              setJuheIptDisabled(false)
              setTimerFlag(false) //关闭定时器
              setJuheText('支付失败或撤销支付，请重新扫码进行支付')
              setPayCode('')
              setCancelPayBtn(false)
            })
        }}
        searchPayState={() => {
          if (!timerFlag) {
            juheFn()
          }
        }}
        onOk={() => {
          setJuheIptShow(false)
          revertPage()
        }}
      ></JuheIptShowModal>
      <PrintTemplateModal
        visible={!!registrationId}
        templateCategory={PrintTemplateCategory.Reg}
        registrationId={registrationId}
        paymentId={printPaymentId}
        treatmentId={printTreatmentId}
        onCancel={() => {
          revertPage()
          if (query.has('redirect') && registrationId) {
            dispatch(
              traceRoute({
                name: '医生门诊',
                path: '/treatment',
                query: `registrationId=${registrationId}`,
              })
            )
          }

          setRegistrationId('')
          setPrintPaymentId('')
          setPrintTreatmentId('')
        }}
      />
      <Modal
        visible={isCancelRegisterModalVisible}
        footer={null}
        destroyOnClose
        centered
        className={styles.modalCancel}
      >
        <div
          style={{
            padding: '32px',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <InfoCircleOutlined
            style={{
              color: '#faad14',
              marginRight: '10px',
              fontSize: '22px',
            }}
          />
          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
            当前为医保患者，是否同时取消挂号?
          </span>
        </div>
        <CloseOutlined
          style={{
            position: 'absolute',
            color: '#8c8c8c',
            right: 10,
            top: 20,
            marginRight: '10px',
            fontSize: '22px',
          }}
          onClick={() => {
            setIsCancelRegisterModalVisible(false)
          }}
        />
        <Row
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
          }}
        >
          <Button
            style={{
              marginRight: '14px',
            }}
            loading={cancelOrSaveLoading}
            onClick={() => {
              setCancelOrSaveLoading(true)
              setTimeout(() => {
                setCancelOrSaveLoading(false)
              }, 3000)
              isInsurance &&
                notification.info({
                  message: '挂号成功，可以到待收费页面中继续收挂号费',
                })

              form.validateFields().then((values) => {
                if (!values.skipPrinting) {
                  setSkipPrintingFlag(true)
                } else {
                  if (query.has('redirect') && (values.skipPrinting && registerData?.registrationId && registerData?.registrationId > 0)) {
                    dispatch(
                      traceRoute({
                        name: '医生门诊',
                        path: '/treatment',
                        query: `registrationId=${registerData?.registrationId}`,
                      })
                    )
                  }
                  revertPage()
                }
              })
              isInsurance && localStorage.removeItem('appointFlag')
              isInsurance && setDepartmentDoctorMessage()
              setIsCancelRegisterModalVisible(false)
              setIsModalVisible(false)
              cancelForm()
            }}
          >
            保留挂号
          </Button>
          <Button
            type='primary'
            loading={cancelOrSaveLoading}
            onClick={() => {
              setCancelOrSaveLoading(true)
              setTimeout(() => {
                setCancelOrSaveLoading(false)
              }, 3000)
              dispatch(getRegisterCancel(registerData?.registrationId))
                .then(unwrapResult)
                .then((v) => {
                  setIsModalVisible(false)
                  notification.success({
                    message: '取消成功',
                  })
                  setSkipPrintingFlag(false)
                  setIsCancelRegisterModalVisible(false)
                  cancelForm()
                  revertPage()
                })
                .catch((v) => {
                  setIsCancelRegisterModalVisible(false)
                  setIsModalVisible(false)
                  cancelForm()
                  revertPage()
                })
            }}
          >
            取消挂号
          </Button>
        </Row>
      </Modal>
      <MedicationAdministrationRecordModal
        insuranceBean={insuranceItem}
        patientId={patientInsurance?.patientId}
        doctorId={form.getFieldValue('registrationDoctorId')}
        visible={isMedicationAdministrationRecordVisible}
        registration={patientInsurance}
        onOK={() => {
          setIsMedicationAdministrationRecordVisible(false)
        }}
        onCancel={() => {
          setIsMedicationAdministrationRecordVisible(false)
        }}
      />
      {showStopAction && (
        <div className={styles.stopAction}>
          正在进行挂号费结算...
          <br />
          请不要离开
        </div>
      )}
      {showJHZFAction && (
        <div className={styles.stopAction}>
          正在等待聚合支付...
          <br />
          请不要离开
        </div>
      )}
      <YBJRJSModal
        patientId={patientId}
        name={form.getFieldValue('name')}
        visible={isYBJRJSModalVisible}
        onCancel={() => {
          setIsYBJRJSModalVisible(false)
        }}
        onOk={() => {
          setIsYBJRJSModalVisible(false)
        }}
      />
      <SettingOptionsModal
        visible={settingOptionsVisible}
        type={settingType}
        onCancel={() => {
          setSettingOptionsVisible(false)
        }}
        onOk={() => {
          setSettingOptionsVisible(false)
        }}
      />
    </Col>
  )
}
